var bodyScrollLockOptions = {
  reserveScrollBarGap: true,
};

// Define a global function to load a script
window.loadScript = function (url) {
  // Check if the script already exists
  var existingScript = document.querySelector(`script[src="${url}"]`);

  if (existingScript) {
    return;
  }

  // Create a new script element
  var script = document.createElement("script");
  script.src = url;
  document.body.appendChild(script);
};

var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, comma, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";

    if (comma == false) dollars = dollars.replace(/,/g, ' ');

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0, false);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, true, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, true, ".", ",");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

/**
 * DOM event delegator
 *
 * The delegator will listen
 * for events that bubble up
 * to the root node.
 *
 * @constructor
 * @param {Node|string} [root] The root node or a selector string matching the root node
 */
function Delegate(root) {
  /**
   * Maintain a map of listener
   * lists, keyed by event name.
   *
   * @type Object
   */
  this.listenerMap = [{}, {}];
  if (root) {
    this.root(root);
  }

  /** @type function() */
  this.handle = Delegate.prototype.handle.bind(this);

  // Cache of event listeners removed during an event cycle
  this._removedListeners = [];
}

/**
 * Start listening for events
 * on the provided DOM element
 *
 * @param  {Node|string} [root] The root node or a selector string matching the root node
 * @returns {Delegate} This method is chainable
 */
Delegate.prototype.root = function (root) {
  const listenerMap = this.listenerMap;
  let eventType;

  // Remove master event listeners
  if (this.rootElement) {
    for (eventType in listenerMap[1]) {
      if (listenerMap[1].hasOwnProperty(eventType)) {
        this.rootElement.removeEventListener(eventType, this.handle, true);
      }
    }
    for (eventType in listenerMap[0]) {
      if (listenerMap[0].hasOwnProperty(eventType)) {
        this.rootElement.removeEventListener(eventType, this.handle, false);
      }
    }
  }

  // If no root or root is not
  // a dom node, then remove internal
  // root reference and exit here
  if (!root || !root.addEventListener) {
    if (this.rootElement) {
      delete this.rootElement;
    }
    return this;
  }

  /**
   * The root node at which
   * listeners are attached.
   *
   * @type Node
   */
  this.rootElement = root;

  // Set up master event listeners
  for (eventType in listenerMap[1]) {
    if (listenerMap[1].hasOwnProperty(eventType)) {
      // Add the 'passive' option for scroll events
      const isScrollEvent = ["wheel", "mousewheel"].indexOf(eventType) !== -1;
      this.rootElement.addEventListener(eventType, this.handle, {
        capture: true,
        passive: isScrollEvent,
      });
    }
  }
  for (eventType in listenerMap[0]) {
    if (listenerMap[0].hasOwnProperty(eventType)) {
      // Add the 'passive' option for scroll events
      const isScrollEvent = ["wheel", "mousewheel"].indexOf(eventType) !== -1;
      this.rootElement.addEventListener(eventType, this.handle, {
        capture: false,
        passive: isScrollEvent,
      });
    }
  }

  return this;
};

/**
 * @param {string} eventType
 * @returns boolean
 */
Delegate.prototype.captureForType = function (eventType) {
  return (
    ["blur", "error", "focus", "load", "resize", "scroll"].indexOf(
      eventType
    ) !== -1
  );
};

/**
 * Attach a handler to one
 * event for all elements
 * that match the selector,
 * now or in the future
 *
 * The handler function receives
 * three arguments: the DOM event
 * object, the node that matched
 * the selector while the event
 * was bubbling and a reference
 * to itself. Within the handler,
 * 'this' is equal to the second
 * argument.
 *
 * The node that actually received
 * the event can be accessed via
 * 'event.target'.
 *
 * @param {string} eventType Listen for these events
 * @param {string|undefined} selector Only handle events on elements matching this selector, if undefined match root element
 * @param {function()} handler Handler function - event data passed here will be in event.data
 * @param {boolean} [useCapture] see 'useCapture' in <https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener>
 * @returns {Delegate} This method is chainable
 */
Delegate.prototype.on = function (eventType, selector, handler, useCapture) {
  let root;
  let listenerMap;
  let matcher;
  let matcherParam;

  if (!eventType) {
    throw new TypeError("Invalid event type: " + eventType);
  }

  // handler can be passed as
  // the second or third argument
  if (typeof selector === "function") {
    useCapture = handler;
    handler = selector;
    selector = null;
  }

  // Fallback to sensible defaults
  // if useCapture not set
  if (useCapture === undefined) {
    useCapture = this.captureForType(eventType);
  }

  if (typeof handler !== "function") {
    throw new TypeError("Handler must be a type of Function");
  }

  root = this.rootElement;
  listenerMap = this.listenerMap[useCapture ? 1 : 0];
  const isScrollEvent =
    ["wheel", "mousewheel", "touchstart", "touchmove"].indexOf(eventType) !==
    -1;

  // Add master handler for type if not created yet
  if (!listenerMap[eventType]) {
    if (root) {
      root.addEventListener(eventType, this.handle, {
        capture: useCapture,
        passive: isScrollEvent,
      });
    }
    listenerMap[eventType] = [];
  }

  if (!selector) {
    matcherParam = null;

    // COMPLEX - matchesRoot needs to have access to
    // this.rootElement, so bind the function to this.
    matcher = matchesRoot.bind(this);

    // Compile a matcher for the given selector
  } else if (/^[a-z]+$/i.test(selector)) {
    matcherParam = selector;
    matcher = matchesTag;
  } else if (/^#[a-z0-9\-_]+$/i.test(selector)) {
    matcherParam = selector.slice(1);
    matcher = matchesId;
  } else {
    matcherParam = selector;
    matcher = Element.prototype.matches;
  }

  // Add to the list of listeners
  listenerMap[eventType].push({
    selector: selector,
    handler: handler,
    matcher: matcher,
    matcherParam: matcherParam,
  });

  return this;
};

/**
 * Remove an event handler
 * for elements that match
 * the selector, forever
 *
 * @param {string} [eventType] Remove handlers for events matching this type, considering the other parameters
 * @param {string} [selector] If this parameter is omitted, only handlers which match the other two will be removed
 * @param {function()} [handler] If this parameter is omitted, only handlers which match the previous two will be removed
 * @returns {Delegate} This method is chainable
 */
Delegate.prototype.off = function (eventType, selector, handler, useCapture) {
  let i;
  let listener;
  let listenerMap;
  let listenerList;
  let singleEventType;

  // Handler can be passed as
  // the second or third argument
  if (typeof selector === "function") {
    useCapture = handler;
    handler = selector;
    selector = null;
  }

  // If useCapture not set, remove
  // all event listeners
  if (useCapture === undefined) {
    this.off(eventType, selector, handler, true);
    this.off(eventType, selector, handler, false);
    return this;
  }

  listenerMap = this.listenerMap[useCapture ? 1 : 0];
  if (!eventType) {
    for (singleEventType in listenerMap) {
      if (listenerMap.hasOwnProperty(singleEventType)) {
        this.off(singleEventType, selector, handler);
      }
    }

    return this;
  }

  listenerList = listenerMap[eventType];
  if (!listenerList || !listenerList.length) {
    return this;
  }

  // Remove only parameter matches
  // if specified
  for (i = listenerList.length - 1; i >= 0; i--) {
    listener = listenerList[i];

    if (
      (!selector || selector === listener.selector) &&
      (!handler || handler === listener.handler)
    ) {
      this._removedListeners.push(listener);
      listenerList.splice(i, 1);
    }
  }

  // All listeners removed
  if (!listenerList.length) {
    delete listenerMap[eventType];

    // Remove the main handler
    if (this.rootElement) {
      this.rootElement.removeEventListener(eventType, this.handle, useCapture);
    }
  }

  return this;
};

/**
 * Handle an arbitrary event.
 *
 * @param {Event} event
 */
Delegate.prototype.handle = function (event) {
  let i;
  let l;
  const type = event.type;
  let root;
  let phase;
  let listener;
  let returned;
  let listenerList = [];
  let target;
  const eventIgnore = "ftLabsDelegateIgnore";

  if (event[eventIgnore] === true) {
    return;
  }

  target = event.target;

  // Hardcode value of Node.TEXT_NODE
  // as not defined in IE8
  if (target.nodeType === 3) {
    target = target.parentNode;
  }

  // Handle SVG <use> elements in IE
  if (target.correspondingUseElement) {
    target = target.correspondingUseElement;
  }

  root = this.rootElement;

  phase = event.eventPhase || (event.target !== event.currentTarget ? 3 : 2);

  // eslint-disable-next-line default-case
  switch (phase) {
    case 1: //Event.CAPTURING_PHASE:
      listenerList = this.listenerMap[1][type];
      break;
    case 2: //Event.AT_TARGET:
      if (this.listenerMap[0] && this.listenerMap[0][type]) {
        listenerList = listenerList.concat(this.listenerMap[0][type]);
      }
      if (this.listenerMap[1] && this.listenerMap[1][type]) {
        listenerList = listenerList.concat(this.listenerMap[1][type]);
      }
      break;
    case 3: //Event.BUBBLING_PHASE:
      listenerList = this.listenerMap[0][type];
      break;
  }

  let toFire = [];

  // Need to continuously check
  // that the specific list is
  // still populated in case one
  // of the callbacks actually
  // causes the list to be destroyed.
  l = listenerList.length;
  while (target && l) {
    for (i = 0; i < l; i++) {
      listener = listenerList[i];

      // Bail from this loop if
      // the length changed and
      // no more listeners are
      // defined between i and l.
      if (!listener) {
        break;
      }

      if (
        target.tagName &&
        ["button", "input", "select", "textarea"].indexOf(
          target.tagName.toLowerCase()
        ) > -1 &&
        target.hasAttribute("disabled")
      ) {
        // Remove things that have previously fired
        toFire = [];
      }
      // Check for match and fire
      // the event if there's one
      //
      // TODO:MCG:20120117: Need a way
      // to check if event#stopImmediatePropagation
      // was called. If so, break both loops.
      else if (listener.matcher.call(target, listener.matcherParam, target)) {
        toFire.push([event, target, listener]);
      }
    }

    // TODO:MCG:20120117: Need a way to
    // check if event#stopPropagation
    // was called. If so, break looping
    // through the DOM. Stop if the
    // delegation root has been reached
    if (target === root) {
      break;
    }

    l = listenerList.length;

    // Fall back to parentNode since SVG children have no parentElement in IE
    target = target.parentElement || target.parentNode;

    // Do not traverse up to document root when using parentNode, though
    if (target instanceof HTMLDocument) {
      break;
    }
  }

  let ret;

  for (i = 0; i < toFire.length; i++) {
    // Has it been removed during while the event function was fired
    if (this._removedListeners.indexOf(toFire[i][2]) > -1) {
      continue;
    }
    returned = this.fire.apply(this, toFire[i]);

    // Stop propagation to subsequent
    // callbacks if the callback returned
    // false
    if (returned === false) {
      toFire[i][0][eventIgnore] = true;
      toFire[i][0].preventDefault();
      ret = false;
      break;
    }
  }

  return ret;
};

/**
 * Fire a listener on a target.
 *
 * @param {Event} event
 * @param {Node} target
 * @param {Object} listener
 * @returns {boolean}
 */
Delegate.prototype.fire = function (event, target, listener) {
  return listener.handler.call(target, event, target);
};

/**
 * Check whether an element
 * matches a tag selector.
 *
 * Tags are NOT case-sensitive,
 * except in XML (and XML-based
 * languages such as XHTML).
 *
 * @param {string} tagName The tag name to test against
 * @param {Element} element The element to test with
 * @returns boolean
 */
function matchesTag(tagName, element) {
  return tagName.toLowerCase() === element.tagName.toLowerCase();
}

/**
 * Check whether an element
 * matches the root.
 *
 * @param {?String} selector In this case this is always passed through as null and not used
 * @param {Element} element The element to test with
 * @returns boolean
 */
function matchesRoot(selector, element) {
  if (this.rootElement === window) {
    return (
      // Match the outer document (dispatched from document)
      element === document ||
      // The <html> element (dispatched from document.body or document.documentElement)
      element === document.documentElement ||
      // Or the window itself (dispatched from window)
      element === window
    );
  }
  return this.rootElement === element;
}

/**
 * Check whether the ID of
 * the element in 'this'
 * matches the given ID.
 *
 * IDs are case-sensitive.
 *
 * @param {string} id The ID to test against
 * @param {Element} element The element to test with
 * @returns boolean
 */
function matchesId(id, element) {
  return id === element.id;
}

/**
 * Short hand for off()
 * and root(), ie both
 * with no parameters
 *
 * @return void
 */
Delegate.prototype.destroy = function () {
  this.off();
  this.root();
};

class Popup {
  constructor(element) {
    this.element = element;
    this.delegateElement = new Delegate(this.element);
    this.pageOverlayElement = document.querySelector(".pageOverlay");
    this.bindEvents();
  }
  bindEvents() {
    this.delegateElement.on(
      "click",
      '[data-action="open-modal"]',
      this.openModal.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="close-modal"]',
      this.closeModal.bind(this)
    );
    document.addEventListener(
      "posted_successfully",
      this.openModalSpecial.bind(this)
    );

    this.onClickOutsideListener = this.closeModal.bind(this);
  }

  openModal() {
    event.preventDefault();
    event.stopPropagation();
    this.pageOverlayElement.classList.add("is-visible");
    this.activeModal = document.getElementById(
      event.target.getAttribute("aria-controls")
    );
    this.activeModal.setAttribute("aria-hidden", "false");
    this.activeModal.style.display = "block";
    this.pageOverlayElement.addEventListener(
      "click",
      this.onClickOutsideListener
    );
    var focus = this.element.querySelector("[data-scrollable]");

    setTimeout(() => {
      trapFocus(this.activeModal);
    }, 100);
    bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
  }
  openModalSpecial() {
    event.preventDefault();
    event.stopPropagation();
    this.pageOverlayElement.classList.add("is-visible");
    this.activeModal = document.getElementById(event.detail.id);
    this.activeModal.setAttribute("aria-hidden", "false");
    var focus = this.element.querySelector("[data-scrollable]");
    this.pageOverlayElement.addEventListener(
      "click",
      this.onClickOutsideListener
    );
    bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
    trapFocus(this.activeModal);
  }
  closeModal() {
    this.activeModal = document.body.querySelector(
      '.Popup[aria-hidden="false"]'
    );
    this.pageOverlayElement.classList.remove("is-visible");
    this.pageOverlayElement.removeEventListener(
      "click",
      this.onClickOutsideListener
    );
    this.activeModal.setAttribute("aria-hidden", "true");

    bodyScrollLock.clearAllBodyScrollLocks();
    this.activeModal.removeAttribute("style");
  }
}

class RevolutionImageZoom {
  constructor(element, slideshow) {
    this.element = element;
    this.slideshow = slideshow;
    this.delegateElement = new Delegate(this.element);
    this.delegateRoot = new Delegate(document.body);
    loadScript(window.theme.pswpScript);
    this.syncHeight();
    this.bindEvents();
  }

  syncHeight() {
    document.documentElement.style.setProperty(
      "--window-inner-height",
      `${window.innerHeight}px`
    );
  }

  bindEvents() {
    window.addEventListener("resize", this.syncHeight());
    this.delegateElement.on(
      "click",
      '[data-action="open-product-zoom"]',
      this.initPhotoSwipe.bind(this)
    );
    this.delegateElement.on(
      "click",
      ".ProductSliderCell--Zoom",
      this.initPhotoSwipeFromImageClick.bind(this)
    );
    this.delegateRoot.on(
      "pswpTap",
      ".pswp__button--close",
      this.photoswiperClose.bind(this)
    );
  }
  photoswiperClose() {
    this.photoSwipeInstance.close;
    if (/iPhone|iPad|iPod/i.test(window.navigator.userAgent)) {
      document.documentElement.classList.remove("pswp-open-in-ios");
    }
  }

  initPhotoSwipe() {
    var images = [],
      index = 0;
    if (this.slideshow) {
      this.slideshow.swiperElement.slides.forEach(function (item) {
        if (item.classList.contains("ProductSliderCell--Zoom")) {
          if (item.querySelector("img")) {
            images.push(item.querySelector("img"));
          }
        }
      });
      index = this.slideshow.swiperElement.realIndex;
      this.slideshow.swiperElement.slides[index]
        .querySelector(".ProductSlider--Element")
        .getAttribute("data-image-position");
    } else {
      images.push(document.querySelector(".ProductSlider--Image"));
    }

    this.createPhotoSwipeInstance(
      this.createPhotoSwipeItemsFromImages(images),
      parseInt(index)
    );
  }

  initPhotoSwipeFromImageClick(event, target) {
    // Check if the current breakpoint is "pocket". If it is, return without doing anything.
    if (new Responsive().matchesBreakpoint("pocket")) {
      return;
    }

    // Create an array of images from the siblings of the target element.
    const images = [];
    const siblings = Array.from(target.parentElement.children);

    siblings.forEach((item) => {
      if (
        item.classList.contains("ProductSliderCell--Zoom") &&
        item.querySelector("img")
      ) {
        images.push(item.querySelector("img"));
      }
    });

    // Get the image position from the target element's data attribute.
    const imagePosition = parseInt(
      target
        .querySelector(".ProductSlider--Element")
        .getAttribute("data-image-position")
    );

    // Create the PhotoSwipe instance using the images and image position.
    this.createPhotoSwipeInstance(
      this.createPhotoSwipeItemsFromImages(images),
      imagePosition
    );
  }

  createPhotoSwipeItemsFromImages(images) {
    return images.map(function (image) {
      var maxWidth = parseInt(image.getAttribute("data-max-width")),
        maxHeight = parseInt(image.getAttribute("data-max-height")),
        maxDimension = new Responsive().matchesBreakpoint("phone")
          ? 1200
          : 2200,
        reduceFactor = 1.0;

      if (maxWidth >= maxHeight) {
        reduceFactor = Math.max(maxWidth / maxDimension, 1.0);
      } else {
        reduceFactor = Math.max(maxHeight / maxDimension, 1.0);
      }
      var requestedWidth = Math.floor(maxWidth / reduceFactor);
      var requestedHeight = Math.floor(maxHeight / reduceFactor);
      return {
        msrc: image.currentSrc || image.src,
        w: requestedWidth,
        h: requestedHeight,
        initialZoomLevel: 0.65,
        src: image.dataset.originalSrc,
      };
    });
  }

  createPhotoSwipeInstance(items, selectedImageIndex) {
    var _this = this;
    var photoswipeContainer = document.querySelector(".pswp");
    this.photoSwipeInstance = new PhotoSwipe(
      photoswipeContainer,
      false,
      items,
      {
        index: selectedImageIndex,
        showHideOpacity: true,
        showAnimationDuration: 500,
        loop: false,
        history: false,
        closeOnVerticalDrag: true,
        allowPanToNext: false,
        pinchToClose: false,
        errorMsg: '<p class="pswp__error-msg"></p>',
        scaleMode: "orig",
        getDoubleTapZoom: function getDoubleTapZoom(isMouseClick, item) {
          if (isMouseClick) {
            return 1.35;
          } else {
            return item.initialZoomLevel < 0.7 ? 1 : 1.33;
          }
        },
        getThumbBoundsFn: function getThumbBoundsFn(index) {
          var allThumbnail = _this.element.querySelectorAll(
            ".mainSwiper .ProductSliderCell--Zoom img"
          ),
            thumbnail = allThumbnail[index],
            pageYScroll =
              window.pageYOffset || document.documentElement.scrollTop,
            rect = thumbnail.getBoundingClientRect();
          return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
        },
      }
    );

    this.photoSwipeInstance.listen(
      "beforeChange",
      this.onslideChanged.bind(this)
    );
    this.photoSwipeInstance.listen(
      "destroy",
      this.destroyPhotoSwipe.bind(this)
    );
    this.photoSwipeInstance.listen("doubleTap", this.onDoubleTap.bind(this));
    this.photoSwipeInstance.listen(
      "initialZoomIn",
      this.onInitialZoomIn.bind(this)
    );
    this.photoSwipeInstance.listen(
      "initialZoomOut",
      this.onInitialZoomOut.bind(this)
    );

    this.delegateRoot.on(
      "pswpTap",
      ".pswp__scroll-wrap",
      this.onSingleTap.bind(this)
    );
    this.delegateRoot.on(
      "pswpTap",
      ".pswp__button--close",
      this.photoSwipeInstance.close
    );
    this.delegateRoot.on(
      "pswpTap",
      ".pswp__button--prev",
      this.photoSwipeInstance.prev
    );
    this.delegateRoot.on(
      "pswpTap",
      ".pswp__button--next",
      this.photoSwipeInstance.next
    );
    this.photoSwipeInstance.listen("close", this.photoswiperClose.bind(this));
    if (/iPhone|iPad|iPod/i.test(window.navigator.userAgent)) {
      document.documentElement.classList.add("pswp-open-in-ios");
    }
    this.photoSwipeInstance.init();
  }

  onslideChanged() {
    if (this.photoSwipeInstance.getCurrentIndex() === 0) {
      this.photoSwipeInstance.scrollWrap
        .querySelector(".pswp__button--prev")
        .setAttribute("disabled", "disabled");
    } else {
      this.photoSwipeInstance.scrollWrap
        .querySelector(".pswp__button--prev")
        .removeAttribute("disabled");
    }

    if (
      this.photoSwipeInstance.getCurrentIndex() + 1 ===
      this.photoSwipeInstance.options.getNumItemsFn()
    ) {
      this.photoSwipeInstance.scrollWrap
        .querySelector(".pswp__button--next")
        .setAttribute("disabled", "disabled");
    } else {
      this.photoSwipeInstance.scrollWrap
        .querySelector(".pswp__button--next")
        .removeAttribute("disabled");
    }
  }

  onSingleTap(event) {
    if (!event.detail || event.detail.pointerType === "mouse") {
      if (event.target.classList.contains("pswp__img")) {
        this.photoSwipeInstance.toggleDesktopZoom(event.detail.releasePoint);
      }
    } else {
      if (event.target.classList.contains("pswp__button")) {
        return;
      }

      event.target
        .closest(".pswp")
        .querySelector(".pswp__ui")
        .classList.toggle("pswp__ui--hidden");
    }
  }

  onDoubleTap(point) {
    var initialZoomLevel = this.photoSwipeInstance.currItem.initialZoomLevel;

    if (this.photoSwipeInstance.getZoomLevel() !== initialZoomLevel) {
      this.photoSwipeInstance.zoomTo(initialZoomLevel, point, 333);
    } else {
      this.photoSwipeInstance.zoomTo(
        initialZoomLevel < 0.7 ? 1 : 1.33,
        point,
        333
      );
    }
  }

  onInitialZoomIn() {
    document.querySelector(".pswp__ui").classList.remove("pswp__ui--hidden");
  }
  onInitialZoomOut() {
    document.querySelector(".pswp__ui").classList.add("pswp__ui--hidden");
  }
  destroyPhotoSwipe() {
    this.delegateRoot.off("pswpTap");
    this.photoSwipeInstance = null;
  }
}


class RevolutionSelectbox {
  constructor(element, popover, additionalOverlay) {
    this.element = element;
    this.popover = popover;
    this.changeOverlay = additionalOverlay;
    this.domDelegate = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.dropdown = this.element.querySelector(".RevolutionSelectbox");
    this.isOpen = false;
    this.mainDropdown = this.element.querySelector(
      ".RevolutionSelectbox--Content"
    );
    this.languageSelector = this.element.classList.contains('RevolutionSelectbox--Selectors');

    this.mainDropdownContent = this.element.querySelector(
      ".RevolutionSelectbox--InnerContent"
    );
    this.mainButton = this.element.querySelector(
      ".RevolutionSelectbox--Button"
    );

    this.headerTransparent = document.body
    .querySelector("#header")
    .classList.contains("Header--Transparent")
    ? true
    : false;

    this.connectedSelect = this.element.getAttribute("data-select");
    this.selectbox = this.element.querySelector(
      "[name=" + this.connectedSelect + "]"
    );
    if (this.selectbox == null) {
      this.selectbox = this.element.querySelector(
        "[name2=" + this.connectedSelect + "]"
      );
    }
    if (this.popover == true) {
      this.mainDropdown.classList.remove("RevolutionSelectbox--animation");
      this.mainDropdown.classList.add("PopoverContent");
      if (this.changeOverlay) {
        this.pageOverlayElement = document.querySelector(
          ".localizationOverlay"
        );
      } else {
        this.pageOverlayElement = document.querySelector(".pageOverlay");
      }
    }
    this.bindEvents();
    if (!this.element.classList.contains("spesh")) {
      this.initSelectbox();
    }
  }

  bindEvents() {
    if (!this.element.classList.contains("spesh")) {
      this.onClickOutsideListener = this.onClickOutside.bind(this);
      this.domDelegate.on(
        "click",
        "[data-action=toggle-selectbox]",
        this.toggleDropdown.bind(this)
      );

      this.domDelegate.on(
        "click",
        "[data-action=selectbox-change]",
        this.selectboxChange.bind(this)
      );

      this.delegateBody.on("menu:open", this.onClickOutside.bind(this));
      this.domDelegate.on("click", "body", this.onClickOutside.bind(this));
    }

    this.domDelegate.on(
      "click",
      "[data-action=selectbox-submit]",
      this.selectboxSubmit.bind(this)
    );
    this.domDelegate.on(
      "keypress",
      "[data-action=selectbox-submit]",
      this.selectboxSubmit.bind(this)
    );
  }

  selectboxChange() {
    var value = event.target.getAttribute("data-value");
    var selectboxID = event.target.getAttribute("data-selectboxid");
    var innerContent = event.target.innerHTML;
    var selEl = this.element.querySelector("#" + selectboxID);
    if (selEl.nodeName == "SELECT") {
      selEl.value = value;
      selEl.dispatchEvent(new Event("change"));
    } else {
      selEl
        .querySelector('[value="' + value + '"]')
        .setAttribute("checked", "true");
    }
    this.mainButton.querySelector(".RevolutionSelectbox--Title").innerHTML =
      innerContent;

    if (this.element.classList.contains("dropdownSelector")) {
      this.element
        .querySelector('.RevolutionSelectbox--Item[disabled="true"]')
        .removeAttribute("disabled");
      event.target.setAttribute("disabled", "true");
    }
    this.closeDropdown(this.element);
  }

  onClickOutside(event) {
    const withinBoundaries = event.composedPath().includes(this.element);
    if (
      !withinBoundaries ||
      event.target.classList.contains("FiltersDesktopWrapper")
    ) {
      this.closeDropdown(this.element);
    }
  }

  selectboxSubmit(event) {
    if (event.key != "Enter" && event.key !== undefined) {
      return;
    }
    var value = event.target.closest("[data-value]").getAttribute("data-value");
    var dataName = event.target.closest("[data-name]").getAttribute("data-name");
    this.selectbox.value = value;
    if (!this.element.classList.contains("spesh")) {
      this.closeDropdown(this.element);
    }
    this.element.querySelector(".RevolutionSelectbox--Title").innerHTML =
      dataName;
    this.selectbox.parentElement.submit();
  }

  initSelectbox() {
    const selectedItem = this.mainDropdown.querySelector(


      '[selected="selected"]'
    ),

      titleElement = this.element.querySelector(".RevolutionSelectbox--Title");
    if (selectedItem) {
      titleElement.innerHTML = selectedItem.getAttribute("data-name");
    }

    trapFocus(this.element);
    this.element.style.display = "block";
  }

  toggleDropdown(event, target) {
    event.preventDefault();

    if (this.isOpen) {
      this.closeDropdown(target);
    } else {
      this.openDropdown(target);
    }
  }

  openDropdown(target) {
    // Dispatch "close:search" and "menu:close" events on the element.
    this.element.dispatchEvent(
      new CustomEvent("close:search", { bubbles: true })
    );
    this.element.dispatchEvent(
      new CustomEvent("menu:close", { bubbles: true })
    );

    // Find all siblings with class ".RevolutionSelectbox".
    const siblings = Array.from(
      target.parentElement.parentElement.children
    ).filter((item) => item.classList.contains("RevolutionSelectbox"));


    if (this.element.classList.contains('RevolutionSelectbox--Selectors') && new Responsive().matchesBreakpoint('lap-and-up') && this.headerTransparent) {
      setTimeout(() => {
        document.querySelector("#header").classList.remove("Header--Transparent");
      }, 1)
      setTimeout(() => {
        document.querySelector("#header").classList.remove("Header--Transparent");
      }, 601)


    }
    // Hide the dropdown content for all siblings.
    siblings.forEach((item) => {
      item
        .querySelector(".RevolutionSelectbox--Button")
        .setAttribute("aria-expanded", false);
      item
        .querySelector(".RevolutionSelectbox--Content")
        .setAttribute("aria-hidden", true);
      item.querySelector(".RevolutionSelectbox--Content").style.display =
        "none";
    });

    // If the dropdown is a popover, show the page overlay and disable body scrolling.
    if (this.popover) {
      this.pageOverlayElement.classList.add("is-visible");
      this.pageOverlayElement.addEventListener(
        "click",
        this.onClickOutsideListener
      );


      trapFocus(this.mainDropdown);

    }

    // Show the dropdown content for the target element and set its state to "expanded".
    const contentElement = target.parentElement.querySelector(
      ".RevolutionSelectbox--Content"
    );
    target.setAttribute("aria-expanded", "true");
    contentElement.style.display = "block";
    contentElement.style.height = `${contentElement.offsetHeight}px`;

    if (this.languageSelector && new Responsive().matchesBreakpoint('lap-and-up')) {
      if (contentElement.scrollHeight > contentElement.offsetHeight) {
        contentElement.style.scrollbarGutter = 'stable';
      }
    }

    if (this.popover) {
      setTimeout(() => {
        contentElement.setAttribute("aria-hidden", "false");
      }, 20);
    } else {
      contentElement.setAttribute("aria-hidden", "false");
    }

    this.isOpen = true;
    window.addEventListener("click", this.onClickOutsideListener);
  }

  closeDropdown(target) {
    if (this.element.classList.contains('RevolutionSelectbox--Selectors') && 
    new Responsive().matchesBreakpoint('lap-and-up') && 
    this.headerTransparent && event.type != 'menu:open' && !event.target.classList.contains('searchItem') && event.type != 'close:search') {

      setTimeout(() => {
        document.body
        .querySelector("#header").toggleColor();
      }, 601)
    }
    var closestDropdown = target.closest(".RevolutionSelectbox");
    if (closestDropdown === null) {
      var closestDropdown = target.querySelector(
        "[aria-expanded='true']"
      ).parentElement;
    }
    closestDropdown
      .querySelector(".RevolutionSelectbox--Button")
      .setAttribute("aria-expanded", false);
    closestDropdown
      .querySelector(".RevolutionSelectbox--Content")
      .setAttribute("aria-hidden", true);
    setTimeout(() => {
      closestDropdown.querySelector(
        ".RevolutionSelectbox--Content"
      ).style.display = "none";
    }, 300);



    if (this.popover == true) {
      this.pageOverlayElement.classList.remove("is-visible");
      this.pageOverlayElement.removeEventListener(
        "click",
        this.onClickOutsideListener
      );



    }
    this.isOpen = false;
    removeTrapFocus(this.mainDropdownContent);
    window.removeEventListener("click", this.onClickOutsideListener);
  }
}

class Form {
  constructor() { }

  serialize(form) {
    function stringKey(key, value) {
      var beginBracket = key.lastIndexOf("[");

      if (beginBracket === -1) {
        var _hash = {};
        _hash[key] = value;
        return _hash;
      }

      var newKey = key.substr(0, beginBracket);
      var newValue = {};

      newValue[key.substring(beginBracket + 1, key.length - 1)] = value;

      return stringKey(newKey, newValue);
    }

    var hash = {};

    for (var i = 0, len = form.elements.length; i < len; i++) {
      var formElement = form.elements[i];

      if (formElement.name === "" || formElement.disabled) {
        continue;
      }

      if (
        formElement.name &&
        !formElement.disabled &&
        (formElement.checked ||
          /select|textarea/i.test(formElement.nodeName) ||
          /hidden|text|search|tel|url|email|password|datetime|date|month|week|time|datetime-local|number|range|color/i.test(
            formElement.type
          ))
      ) {
        var stringKeys = stringKey(formElement.name, formElement.value);
        hash = this.extend(hash, stringKeys);
      }
    }

    return hash;
  }
  extend() {
    var extended = {},
      i = 0,
      _this = this;

    // Merge the object into the extended object
    var merge = function merge(obj) {
      for (var prop in obj) {
        if (obj.hasOwnProperty(prop)) {
          // If property is an object, merge properties
          if (Object.prototype.toString.call(obj[prop]) === "[object Object]") {
            extended[prop] = _this.extend(extended[prop], obj[prop]);
          } else {
            extended[prop] = obj[prop];
          }
        }
      }
    };

    // Loop through each object and conduct a merge
    for (; i < arguments.length; i++) {
      merge(arguments[i]);
    }

    return extended;
  }
}

class AddToCart {
  constructor() {
    this.element = document.body;
    this.delegateElement = new Delegate(this.element);
    this.pageLoader = document.body.querySelector(".pageLoader");
    this.bindEvents();
  }
  bindEvents() {
    this.delegateElement.on(
      "click",
      "[data-action=add-to-cart]",
      this.addToCart.bind(this)
    );
  }

  addToCart() {
    var _this = this;
    event.preventDefault();
    if (_this.disableFunction || event.target.closest('form').querySelector('.accent')) return;
    if (event.target.closest('[data-action="add-to-cart"]').getAttribute("disabled") === 'disabled') return;
    var addToCartButton = event.target;
    this.pageLoader.style.width = 100 + "%";
    addToCartButton.setAttribute("disabled", "disabled");
    var formElement = event.target.closest("form");
    formElement.querySelector('[name="id"]').removeAttribute("disabled");
    var formHelper = new Form();
    const serialized = formHelper.serialize(formElement);
    fetch(window.routes.localeRootUrl + "/cart/add.js", {
      body: JSON.stringify(serialized),
      credentials: "same-origin",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
    }).then(function (response) {
      if (response.ok) {
        if (window.location.href.indexOf("cart") != -1) {
          location.reload();
          return;
        }
        addToCartButton.removeAttribute("disabled");
        _this.element.dispatchEvent(
          new CustomEvent("product:added", {
            bubbles: true,
            detail: {
              variant: serialized.id,
              quantity: serialized.quantity,
            },
          })
       
        );
        _this.element.dispatchEvent(
          new CustomEvent("drawer:close-product", { bubbles: true })
        );
      } else {
        response.json().then(function (content) {
          if (_this.element.querySelector(".ProductForm--Error")) {
            _this.element
              .querySelector(".ProductForm--Error")
              .classList.add("visible");
            setTimeout(function () {
              _this.element
                .querySelector(".ProductForm--Error")
                .classList.remove("visible");
            }, 2500);
            _this.pageLoader.style.left = "unset";
            _this.pageLoader.style.right = 0 + "px";
            _this.pageLoader.style.width = 0 + "%";
            setTimeout(() => {
              _this.pageLoader.style.left = 0 + "px";
              _this.pageLoader.style.right = "unset";
            }, 550);
          } else {
            var errorMessageElement = document.createElement("span");
            errorMessageElement.className = "u-p3 accent";
            errorMessageElement.innerHTML = content["description"];
            addToCartButton.removeAttribute("disabled");
            addToCartButton.closest('button').insertAdjacentElement(
              "afterend",
              errorMessageElement
            );
            _this.disableFunction = true;
            setTimeout(function () {
              errorMessageElement.remove();
              _this.disableFunction = false;
            }, 2500);
            _this.pageLoader.style.left = "unset";
            _this.pageLoader.style.right = 0 + "px";
            _this.pageLoader.style.width = 0 + "%";
            setTimeout(() => {
              _this.pageLoader.style.left = 0 + "px";
              _this.pageLoader.style.right = "unset";
            }, 550);
          }
        });
      }
    });
  }
}

new AddToCart();

/*GLOBAL FUNCTIONS */

function handleFirstTab(e) {
  if (e.keyCode === 9) {
    document.body.classList.add("user-is-tabbing");

    window.removeEventListener("keydown", handleFirstTab);
    window.addEventListener("mousedown", handleMouseDownOnce);
  }
}

function handleMouseDownOnce() {
  document.body.classList.remove("user-is-tabbing");

  window.removeEventListener("mousedown", handleMouseDownOnce);
  window.addEventListener("keydown", handleFirstTab);
}

window.addEventListener("keydown", handleFirstTab);

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe, .focusable"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);
  if (first) {
    first.focus();
  } else {
    elementToFocus.focus();
  }
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

class Responsive {
  constructor() {
    var _this = this;

    this.currentBreakpoint = this.getCurrentBreakpoint();

    window.addEventListener("resize", function () {
      var newBreakpoint = _this.getCurrentBreakpoint();

      if (_this.currentBreakpoint === newBreakpoint) {
        return;
      }

      document.dispatchEvent(
        new CustomEvent("breakpoint:changed", {
          detail: {
            previousBreakpoint: _this.currentBreakpoint,
            currentBreakpoint: newBreakpoint,
          },
        })
      );

      _this.currentBreakpoint = newBreakpoint;
    });
  }

  matchesBreakpoint(breakpoint) {
    switch (breakpoint) {
      case "phone":
        return window.matchMedia("screen and (max-width: 640px)").matches;

      case "tablet":
        return window.matchMedia(
          "screen and (min-width: 641px) and (max-width: 1024px)"
        ).matches;

      case "tablet-and-up":
        return window.matchMedia("screen and (min-width: 768px)").matches;

      case "pocket":
        return window.matchMedia("screen and (max-width: 1024px)").matches;

      case "lap-and-up":
        return window.matchMedia("screen and (min-width: 1025px)").matches;

      case "desk":
        return window.matchMedia("screen and (min-width: 1280px)").matches;
    }
  }
  getCurrentBreakpoint() {
    if (window.matchMedia("screen and (max-width: 640px)").matches) {
      return "phone";
    }

    if (
      window.matchMedia("screen and (min-width: 641px) and (max-width: 1024px)")
        .matches
    ) {
      return "tablet";
    }

    if (
      window.matchMedia(
        "screen and (min-width: 1008px) and (max-width: 1279px)"
      ).matches
    ) {
      return "lap";
    }

    if (window.matchMedia("screen and (min-width: 1280px)").matches) {
      return "desk";
    }
  }
}

class Dropdown {
  constructor() {
    this.domDelegate = new Delegate(document.body);
    this.breakpoint = new Responsive().getCurrentBreakpoint();
    this.allDropdowns = document.querySelectorAll(".Dropdown");
    this.pageOverlayElement = document.querySelector(".pageOverlay");

    this.bindEvents();
  }

  bindEvents() {
    // Bind event for general dropdown toggle
    this.domDelegate.on(
      "click",
      "[data-action=toggle-dropdown]",
      this.toggleDropdown.bind(this)
    );

    let selector;
    switch (this.breakpoint) {

      case "lap-and-up":
        // For lap-and-up breakpoint, bind event for desktop dropdown toggle
        selector = "[data-action=toggle-desktop-dropdown]";
        break;
      case "pocket":
        // For pocket breakpoint, bind event for mobile dropdown toggle
        selector = "[data-action=toggle-mobile-dropdown]";
        break;
      case "phone":
        // For pocket breakpoint, bind event for mobile dropdown toggle
        selector = "[data-action=toggle-mobile-dropdown]";
        break;
      case "tablet":
        // For pocket breakpoint, bind event for mobile dropdown toggle
        selector = "[data-action=toggle-mobile-dropdown]";
        break;
      default:
        // If no specific breakpoint, set selector as false to skip binding
        selector = false;
        break;
    }

    if (selector) {
      // Bind event for specific breakpoint dropdown toggle
      this.domDelegate.on("click", selector, this.toggleDropdown.bind(this));
    }
  }

  openDropdown(elem, target) {
    this.lock = true;
    // Open the dropdown by setting appropriate attributes and performing animation
    const DropdownButton = elem.querySelector(".Dropdown--Button");
    const DropdownContent = elem.querySelector(".Dropdown--Content");

    this.allDropdowns.forEach((dropdown) => {
      if (
        dropdown !== target.closest(".Dropdown") &&
        dropdown.querySelector("[aria-expanded='true']") &&
        !dropdown.classList.contains("do-not-close")
      ) {
        this.closeDropdown(dropdown);
      }
    });

    DropdownButton.setAttribute("aria-expanded", "true");

    new RevolutionAnimation(DropdownContent, "true").slideDown();

    setTimeout(() => {

      this.lock = false;
    }, 300);
  }

  closeDropdown(elem) {
    this.lock = true;
    // Close the dropdown by setting appropriate attributes and performing animation
    const DropdownButton = elem.querySelector(".Dropdown--Button");
    const DropdownContent = elem.querySelector(".Dropdown--Content");

    new RevolutionAnimation(DropdownContent, "true").slideUp();
    DropdownButton.setAttribute("aria-expanded", false);

    setTimeout(() => {
      if (DropdownContent.getAttribute("aria-hidden") == "false") {
        DropdownContent.setAttribute("aria-hidden", "true");
      }

      this.lock = false;
    }, 300);
  }

  toggleDropdown(event, target) {
    event.preventDefault();
    const mainDropdown = target.closest(".Dropdown");
    const isOpen = target.getAttribute("aria-expanded") === "true";

    if (!this.lock) {
      if (isOpen) {
        // If dropdown is open, close it
        this.closeDropdown(mainDropdown, target);
      } else {
        // If dropdown is closed, open it
        this.openDropdown(mainDropdown, target);
      }
    }
  }
}

const allDropdowns = new Dropdown();

class RevolutionSwiper {
  constructor(element, additionalSwiper) {
    var options =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this.element = element;
    this.thumb = additionalSwiper;
    this.initialConfig = JSON.parse(
      element.getAttribute("data-swiper-settings")
    );

    if (additionalSwiper) {
      this.initialConfigThumbs = JSON.parse(
        additionalSwiper.getAttribute("data-swiper-thumb-settings")
      );
    }
    this.options = options;
    this.build();
  }

  selectCell(index) {
    this.swiperElement.slideTo(index);
  }

  nextSlide() {
    this.swiperElement.slideNext(400, false);
  }

  resize() {
    this.swiperElement.resize();
  }

  build() {
    var _this = this,
      configThumb = this.initialConfigThumbs;
    if (configThumb != null) {
      this.thumbSwiper = new Swiper(this.thumb, configThumb);
      this.initialConfig.thumbs["swiper"] = this.thumbSwiper;
    }

    this.swiperElement = new Swiper(this.element, this.initialConfig);
    this.selectedIndex = this.swiperElement.activeIndex;

    this.swiperElement.on("slideChange", function () {
      _this.element.dispatchEvent(
        new CustomEvent("swiper:slide-changed", {
          bubbles: true,
          detail: {
            currentIndex: _this.swiperElement.activeIndex,
            element: _this.swiperElement.el[0],
          },
        })
      );
    });
  }

  destroyInstance() {
    this.swiperElement.destroy();
    if (this.thumbSwiper) {
      this.thumbSwiper.destroy();
    }


  }
}

let cartOpen = false;
class Drawer {
  constructor(element) {

    this.element = element;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.pageOverlayElement = document.querySelector(".pageOverlay");

    if(this.element.id == 'productDrawer') {
      this.pageOverlayElement = document.querySelector(".cart_drawer-overlay");
    }

    this.localizationOverlay = document.querySelector(
      ".localizationOverlay"
    );
    this.sizeGuideOverlay = document.querySelector(".sizeGuideOverlay");
    this.headerTransparent = document.body
      .querySelector("#header")
      .classList.contains("Header--Transparent")
      ? true
      : false;
    if (navigator.platform === "iPhone")
      document.documentElement.style.setProperty(
        "--viewport-height",
        `${window.innerHeight}px`
      );

    this.isOpen = false;

    this.bindEvents();
  }

  bindEvents() {
    this.delegateBody.on(
      "click",
      '[data-action="open-drawer"][data-toggle-id="' + this.element.id + '"]',
      this.openDrawer.bind(this)
    );
    this.delegateBody.on(
      "click",
      '[data-action="close-drawer"][data-toggle-id="' + this.element.id + '"]',
      this.closeDrawer.bind(this)
    );
    this.delegateBody.on(
      "click",
      '[data-action="toggle-drawer"][data-toggle-id="' + this.element.id + '"]',
      this.toggleDrawer.bind(this)
    );

  if(this.element.id == 'productDrawer') {    this._closeProduct = this.closeProductDrawer.bind(this);
    this.delegateBody.on("drawer:close-product", this._closeProduct);}


    this._openListener = this.openDrawer.bind(this);
    this._closeListener = this.closeDrawer.bind(this);
    this.calculateMaxHeightListener = this.maxHeight.bind(this);
    window.addEventListener("resize", this.calculateMaxHeightListener);

    this.delegateBody.on("drawer:close-other", this._closeListener);
  }

  maxHeight() {
    if (this.element.getAttribute("id") == 'selectorsDrawer') {
      return;
    }
    this.element.style.height = window.innerHeight + "px";
    const elementId = this.element.getAttribute("id");

    switch (elementId) {
      case "mobile-menu":
        this.adjustMobileMenu();
        break;
      case "cart":
        this.adjustCart();
        break;
      case "favorites-drawer":
        this.adjustFavoritesDrawer();
        break;
      default:
        break;
    }
  }

  adjustMobileMenu() {
    const visibleHeightHeader = parseInt(
      getComputedStyle(document.documentElement).getPropertyValue(
        "--header-dynamic-height"
      ),
      10
    );
    const visibleHeightAnnBar = parseInt(
      getComputedStyle(document.documentElement).getPropertyValue(
        "--announcement-dynamic-height"
      ),
      10
    );
    const footerHeightDrawer =
      this.element.querySelector(".Drawer--Footer").offsetHeight;

    this.element.querySelector(
      "#mobile-menu .first-level__wrapper"
    ).style.height = `calc(100% - ${footerHeightDrawer}px)`;

    this.element.style.height =
      window.innerHeight - visibleHeightAnnBar - visibleHeightHeader + "px";
  }

  adjustCart() {
    var footer = this.element.querySelector(".CartDrawer--Footer");
    var footerHeight = 0;
    if (footer !== null) {
      footerHeight = footer.offsetHeight;
    }

    var headerEl = this.element.querySelector(".CartHeader");
    var header = 0;
    if (headerEl) {
      header = headerEl.offsetHeight;
      if (this.element.querySelector(".emptyItem")) header = 0;
    }

    var itemWrapper = this.element.querySelector(".CartItems--Wrapper");
    if (itemWrapper !== null) {
      itemWrapper.style.height = window.innerHeight - footerHeight - header + "px";
    }
  }

  adjustFavoritesDrawer() {
    const header = document.querySelector(".favorites-drawer_header-wrapper");
    let headerHeight = header ? header.offsetHeight : "80px";
    document.documentElement.style.setProperty("--favorites-header", `${headerHeight}px`);
  }

  toggleDrawer() {
    event.preventDefault();
    this.isOpen ? this.closeDrawer() : this.openDrawer();
  }

  openDrawer() {
    if (this.isOpen) {
      return;
    }

    this.element.style.display = 'block';
    this.element.removeEventListener("transitionend", this.transitionEndedListener);

    if (this.element.id != "productDrawer") {
      this.element.dispatchEvent(
        new CustomEvent("close:search", { bubbles: true })
      );
    } else {
      this.element.dispatchEvent(
        new CustomEvent("product:opened", {
          bubbles: true,
          detail: {
            product: event.target.closest('[data-productid]').dataset.productid,
            colorOption: event.target.closest('[data-productid]').querySelector('.product-card__input-selectbox:checked')?.value
          },
        })
      );
    }

    if (this.element.id != 'selectorsDrawer' && this.element.id != 'sizeGuideDrawer') {
      this.element.dispatchEvent(
        new CustomEvent("drawer:close-other", { bubbles: true })
      );
    } else if (this.element.id == 'selectorsDrawer') {
      this.localizationOverlay.classList.add('is-visible');
    } else if (this.element.id == 'sizeGuideDrawer') {
      this.sizeGuideOverlay.classList.add('is-visible');
      this.sizeGuideOverlay.addEventListener("click", this._closeListener);
    }

    if (this.element.getAttribute("id") == "cart") {
      this.element.dispatchEvent(
        new CustomEvent("cart-drawer:open", { bubbles: true })
      );
      cartOpen = true;
    }


    this.maxHeight();

    if (this.element.getAttribute("id") != "mobile-menu") {
      if (this.element.id != 'sizeGuideDrawer') {
        this.pageOverlayElement.classList.add("is-visible");
        this.pageOverlayElement.addEventListener("click", this._closeListener);
      }
    } else {
      this.hamburger = document.body.querySelector(".header--Hamburger");
      this.hamburger.classList.add('is-active');

      if (this.headerTransparent) {
        document.body
          .querySelector("#header")
          .classList.remove("Header--Transparent");
      }
    }


    setTimeout(() => {
      this.element.setAttribute("aria-expanded", "true");
    }, 10);

    const focus = this.element.querySelector("[data-scrollable]");

    bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
    document.body.classList.add("scrollLock");
    this.isOpen = true;
    setTimeout(() => {
      trapFocus(this.element);
    }, 400);

    return false;
  }

  closeDrawer(event) {

    if (!this.isOpen || event && event.target.id == 'productDrawer') {
      return;
    }



    if (event) {
      event.preventDefault();
    }

 
    if (this.element.getAttribute("id") == "cart") {

      var options = JSON.parse(this.element.getAttribute("data-settings"));
      if (options["showRecommendations"]) {

        setTimeout(() => {
          this.element.querySelector(".cartRecommendations").innerHTML = "";
        }, 800);
      }
    }


    this.element.setAttribute("aria-expanded", "false");
    this.isOpen = false;


    if (this.element.id != 'sizeGuideDrawer') {
      if (this.element.getAttribute("id") != "mobile-menu") {
   
          this.pageOverlayElement.classList.remove("is-visible");
          this.pageOverlayElement.removeEventListener("click", this._closeListener);
        
     
      } else {
        this.hamburger.classList.remove('is-active');
        this.hamburger.style.pointerEvents = 'none';
      }
    }

    if (this.localizationOverlay.classList.contains('is-visible')) {
      this.localizationOverlay.classList.remove('is-visible');
    }

    if (this.sizeGuideOverlay && this.sizeGuideOverlay.classList.contains('is-visible')) {
      this.sizeGuideOverlay.classList.remove('is-visible');
      this.sizeGuideOverlay.removeEventListener("click", this._closeListener);
    }

    this.transitionEndedListener = this.translateTransitionEnded.bind(this);
    this.element.addEventListener("transitionend", this.transitionEndedListener);

    if (!this.element.querySelector('.body-scroll-disable')) {
      let focus = this.element.querySelector("[data-scrollable]");
      bodyScrollLock.enableBodyScroll(focus);
    }

     
    if (this.element.getAttribute("id") == "cart") {
      cartOpen = false;}

    if (new Responsive().matchesBreakpoint('phone') && this.element.id == 'selectorsDrawer') return;
    document.body.classList.remove("scrollLock");
  }

  closeProductDrawer(){
    if (!this.isOpen) {
      return;
    }


    if (event) {
      event.preventDefault();
    }


    this.element.setAttribute("aria-expanded", "false");
    this.isOpen = false;

    this.pageOverlayElement.classList.remove("is-visible");
    this.pageOverlayElement.removeEventListener("click", this._closeListener);
  

    

    this.transitionEndedListener = this.translateTransitionEnded.bind(this);
    this.element.addEventListener("transitionend", this.transitionEndedListener);

    if (!this.element.querySelector('.body-scroll-disable')) {
      let focus = this.element.querySelector("[data-scrollable]");
      bodyScrollLock.enableBodyScroll(focus);
    }
  }

  translateTransitionEnded() {
    if (event.propertyName == 'transform' && this.element.getAttribute("aria-expanded") === "false") {
      if (this.element.getAttribute("id") == "mobile-menu") {
        this.element.dispatchEvent(
          new CustomEvent("menuDrawer:closed", { bubbles: true })
        );
        this.hamburger.style.pointerEvents = 'all';

        if (this.headerTransparent) {
          document.body
            .querySelector("#header")
            .toggleColor();
        }
      }
      if (new Responsive().matchesBreakpoint('phone') && this.element.id == 'selectorsDrawer') return;


      removeTrapFocus(this.element);
      this.element.style.display = 'none';

      this.element.removeEventListener("transitionend", this.transitionEndedListener);
    }
  }
}

class RevolutionAnimation {
  constructor(element, directAnimation) {
    this.element = element;
    if (!directAnimation) {
      this.intersectionObserver = [];
      this.integer = 0;
      var contentToAnimate = document.querySelectorAll("[data-animation]");
      contentToAnimate.forEach((item, i) => {
        this.animateElement(item, i);
        this.integer = this.integer + 1;
      });

      // Listen for changes to the DOM and animate any new elements
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === Node.ELEMENT_NODE) {
              const newContentToAnimate =
                node.querySelectorAll("[data-animation]");

              newContentToAnimate.forEach((item, i) => {
                this.animateElement(item, this.integer);
                this.integer = this.integer + 1;
              });
            }
          });
        });
      });

      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  slideUp() {
    this.element.style.height = this.element.scrollHeight + "px";
    this.element.offsetHeight;
    this.element.style.height = 0;
  }

  slideDown() {
    if (this.element.style.height === "auto") {
      return;
    }
    this.element.style.pointerEvents = "none";
    var _this = this;
    this.element.style.height = this.element.scrollHeight + "px";
    this.element.setAttribute("aria-hidden", false);
    var transitionEnded = function transitionEnded(event) {
      _this.element.style.pointerEvents = "all";
      if (event.propertyName === "height") {
        _this.element.style.height = "auto";
        _this.element.removeEventListener("transitionend", transitionEnded);
      }
    };

    this.element.addEventListener("transitionend", transitionEnded);
  }

  // A function to animate a list of elements by scaling them out
  elementScaleOut(elements) {
    // Get the animation duration and delay from the theme settings
    const animationDuration = window.theme.animationDuration * 2;
    const animationDelay = window.theme.animationBetweenElements;

    // Loop through each element in the list
    elements.forEach((element, index) => {
      // Check if the element has already been loaded
      if (element.hasAttribute("data-loaded")) {
        // If so, skip this element
        return;
      }

      // Mark the element as loaded to prevent duplicate animations
      element.setAttribute("data-loaded", true);

      // Define the animation keyframes
      const keyframes = [
        { transform: "scale(104%)", opacity: "0" },
        { transform: "scale(100%)", opacity: "1" },
      ];

      // Define the animation options
      const animationOptions = {
        duration: animationDuration,
        fill: "forwards",
      };

      // Schedule the animation with a delay based on the element's position in the list
      setTimeout(() => {
        element.animate(keyframes, animationOptions);
      }, animationDelay * index);
    });
  }

  elementScaleIn(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "scale(96%)", opacity: "0" },
          { transform: "scale(100%)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration * 2,
          fill: "forwards",
        });
      }, window.theme.animationBetweenElements * i);
      item.setAttribute("data-loaded", true);
    });
  }

  elementFromTop(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateY(-30px)", opacity: "0" },
          { transform: "translateY(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
      }, window.theme.animationBetweenElements * i);
      item.setAttribute("data-loaded", true);
    });
  }

  elementFromBottom(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateY(30px)", opacity: "0" },
          { transform: "translateY(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
      }, window.theme.animationBetweenElements * i);
      item.setAttribute("data-loaded", true);
    });
  }

  elementFromRight(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateX(30px)", opacity: "0" },
          { transform: "translateX(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
        item.setAttribute("data-loaded", true);
      }, window.theme.animationBetweenElements * i);
    });
  }
  elementFromLeft(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateX(-30px)", opacity: "0" },
          { transform: "translateX(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
        item.setAttribute("data-loaded", true);
      }, window.theme.animationBetweenElements * i);
    });
  }
  elementFromRightBig(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateX(120px)", opacity: "0" },
          { transform: "translateX(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
        item.setAttribute("data-loaded", true);
      }, window.theme.animationBetweenElements * i);
    });
  }
  elementFromLeftBig(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateX(-120px)", opacity: "0" },
          { transform: "translateX(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
      }, window.theme.animationBetweenElements * i);
      item.setAttribute("data-loaded", true);
    });
  }

  animateElement(animatedItem, index) {
    const options = {
      integer: index,
      type: animatedItem.dataset.animation,
    };

    if (this.intersectionObserver[index]) {
      this.intersectionObserver[index].disconnect();
    }

    this.intersectionObserver[index] = new IntersectionObserver(
      (results) => {
        const integer = options.integer;
        const elements = [];

        // Iterate over the IntersectionObserverEntry objects in the results array.
        results.forEach((result) => {
          // Check if the target element is intersecting the root element or if its intersection ratio is greater than 0.
          if (result.isIntersecting || result.intersectionRatio > 0) {
            // Add the target element to the elements array.
            elements.push(result.target);
            // Unobserve the target element.
            this.intersectionObserver[integer].unobserve(result.target);
          }
        });

        // If there are no elements to reveal, return.
        if (elements.length === 0) {
          return;
        }

        // An object that maps each animation type to the corresponding animation function.
        const animations = {
          elementFromTop: "elementFromTop",
          elementFromBottom: "elementFromBottom",
          elementFromRight: "elementFromRight",
          elementFromLeft: "elementFromLeft",
          elementFromLeftBig: "elementFromLeftBig",
          elementFromRightBig: "elementFromRightBig",
          elementScaleIn: "elementScaleIn",
          elementScaleOut: "elementScaleOut",
        };

        // Get the animation function corresponding to the type from the animations object.
        const animation = animations[options.type];
        // If the animation function exists, call it with the elements array.
        if (animation) {
          this[animation](elements);
        }
      },
      { threshold: 0.25 }
    );

    if (animatedItem.classList.contains("animatedContent")) {
      this.intersectionObserver[index].observe(animatedItem);
    }

    animatedItem.querySelectorAll(".animatedContent").forEach((item) => {
      this.intersectionObserver[index].observe(item);
    });
  }
}

if (window.theme.enableAnimations) {
  document.addEventListener("DOMContentLoaded", function () {
    new RevolutionAnimation();
  });
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.input = this.querySelector("input");
    this.changeEvent = new Event("quantity:changed", { bubbles: true });
    this.options = JSON.parse(this.element.getAttribute("data-settings"));

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);

    if (this.options["noVariants"] == "true") {
      this.toggleAddButton();
    }
  }

  toggleAddButton() {
    let quantity = "";
    const addButton = document.querySelector(".ProductPage--ATC"),
      addButtonInner = addButton.querySelector(".SelfAlign"),
      quantityEl = document.querySelector(".QuantitySelector__ProductQuantity");
    if (quantityEl) {
      quantity = quantityEl.value();
    }
    if (window.variantInfo.show_icon) {
      var buySvg =
        '<svg class="Svg Svg--shopping_cart mr-m" width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M25.31 5.19547C25.1687 5.02127 24.9568 4.91946 24.7325 4.91797H9.11751L9.60501 6.41797H23.75L21.7475 15.418H10.4975L7.07001 4.56547C6.99476 4.33174 6.80986 4.14965 6.57501 4.07797L3.50001 3.13297C3.24278 3.05393 2.96292 3.11812 2.76584 3.30137C2.56877 3.48461 2.48443 3.75907 2.54459 4.02137C2.60476 4.28366 2.80028 4.49393 3.05751 4.57297L5.75001 5.39797L9.19251 16.273L7.96251 17.278L7.86501 17.3755C7.2374 18.0987 7.21221 19.1659 7.80501 19.918C8.21952 20.4221 8.84817 20.7002 9.50001 20.668H22.0175C22.4317 20.668 22.7675 20.3322 22.7675 19.918C22.7675 19.5038 22.4317 19.168 22.0175 19.168H9.38001C9.20436 19.162 9.0446 19.0646 8.95873 18.9113C8.87286 18.7579 8.87334 18.5709 8.96001 18.418L10.7675 16.918H22.3475C22.705 16.9267 23.0189 16.6818 23.0975 16.333L25.475 5.83297C25.5212 5.6064 25.4603 5.37117 25.31 5.19547ZM20.75 25.168C21.682 25.168 22.4375 24.4125 22.4375 23.4805C22.4375 22.5485 21.682 21.793 20.75 21.793C19.818 21.793 19.0625 22.5485 19.0625 23.4805C19.0625 24.4125 19.818 25.168 20.75 25.168ZM12.185 23.4805C12.185 24.4125 11.4295 25.168 10.4975 25.168C9.56553 25.168 8.81001 24.4125 8.81001 23.4805C8.81001 22.5485 9.56553 21.793 10.4975 21.793C11.4295 21.793 12.185 22.5485 12.185 23.4805Z" fill="#121212"></path></svg>';
    } else {
      var buySvg = "";
    }

    if (!addButton) return;
    if (!quantity) {
      quantity = 1;
    }

    addButton.removeAttribute("disabled");
    addButton.classList.remove("ProductCard--Sold__Out");
    if (window.variantInfo.show_price) {
      var priceElement =
        "<span class='u-p3 ml-s'>" +
        Shopify.formatMoney(
          this.options["price"] * quantity,
          window.theme.moneyFormat
        );
      +"</span>";
    } else {
      var priceElement = "";
    }

    addButtonInner.innerHTML =
      buySvg + window.variantStrings.addToCart + priceElement;
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = (form) => {
  const obj = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }
  return JSON.stringify(obj);
};

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options,
  copped
) {
  if (!copped) this.countryEl = document.getElementById(country_domid);
  else this.countryEl = country_domid;
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  if (this.provinceEl) this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    if (this.provinceEl) {
      this.clearOptions(this.provinceEl);
      if (provinces && provinces.length == 0) {
        this.provinceContainer.style.display = "none";
      } else {
        for (var i = 0; i < provinces.length; i++) {
          var opt = document.createElement("option");
          opt.value = provinces[i][0];
          opt.innerHTML = provinces[i][1];
          this.provinceEl.appendChild(opt);
        }

        this.provinceContainer.style.display = "";
      }
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};


class Countdown extends HTMLElement {
  constructor() {
    super();
    this.element = this;

    const counterWrapper = this.element.querySelector(
      ".component-countDownWrapper"
    );

    this.options = JSON.parse(this.element.getAttribute("data-settings"));
    let counterString = this.options["countdownString"];
    counterString = counterString.replace(
      "{countdown}",
      '<span class="u-pb6 component-countDown">00:00:00</span>'
    );
    counterWrapper.innerHTML = counterString;

    const dateNow = new Date();
    const todaysDay = dateNow.getDay();

    const countdownDay = this.options.countdownDays;

    this.dayDifference = countdownDay - todaysDay;

    if (this.dayDifference < 0) {
      // If the countdown day is earlier in the week, add 7 to the difference
      this.dayDifference += 7;
    }

    this.counter = this.element.querySelector(".component-countDown");
    setInterval(this.countDown.bind(this), 1000);
  }

  countDown() {
    const dateNow = new Date();
    const currentHours = dateNow.getHours();
    const currentMinutes = dateNow.getMinutes();
    let countDate = new Date(`March 3, 2099 ${this.options.countdownTime}`);

    if (this.options["countdownType"] == "to_date") {
      countDate = new Date(this.options.countdownDate);
    }

    const difference = countDate - dateNow;

    const seconds = 1000;
    const minutes = seconds * 60;
    const hours = minutes * 60;
    const days = hours * 24;

    let textDays = Math.floor(difference / (1000 * 60 * 60 * 24));
    let textHours = Math.floor((difference % days) / hours);
    let textMinutes = Math.floor((difference % hours) / minutes);
    let textSeconds = Math.floor((difference % minutes) / seconds);

    const [targetHours, targetMinutes] = this.options.countdownTime
      .split(":")
      .map(Number);
    if (
      targetHours < currentHours ||
      (targetHours === currentHours &&
        targetMinutes <= currentMinutes &&
        this.options["countdownType"] == "reccuring")
    ) {
      textDays = this.dayDifference - 1;
    } else if (this.options["countdownType"] == "reccuring") {
      textDays = this.dayDifference;
    }

    const displayHours = textHours;
    const formatHours = displayHours < 10 ? `0${displayHours}` : displayHours;
    const formatMinutes = textMinutes < 10 ? `0${textMinutes}` : textMinutes;
    const formatSeconds = textSeconds < 10 ? `0${textSeconds}` : textSeconds;

    if (textDays > 0) {
      this.counter.innerText = `${textDays}d ${formatHours}:${formatMinutes}:${formatSeconds}`;
    } else {
      this.counter.innerText = `${formatHours}:${formatMinutes}:${formatSeconds}`;
    }
  }
}

customElements.define("countdown-element", Countdown);

var firstOpen = true;
class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.sidebarDrawer = new Drawer(this.element);
    this.loader = this.element.querySelector(".itemLoader");
    this.cartCount = document.querySelector(".CartCount");
    this.options = JSON.parse(this.element.getAttribute("data-settings"));
    this.pageLoader = document.body.querySelector(".pageLoader");
    this.breakpoint = new Responsive().getCurrentBreakpoint();
    this.changeEvent = new Event("quantity:changed", { bubbles: true });
    this.loadedOnOpen = false;
    window.theme.cartCount > 0
      ? this.cartCount.classList.add("u-s4")
      : this.cartCount.classList.remove("u-s4");
    this.recommendationsLoaded = false;

    if (window.theme.enableAnimations) {
      new RevolutionAnimation(this.element);
    }
    // Load recommendations if the option is enabled.
    if (this.options.showRecommendations) {
      this.loadRecommendations();

    }

    this.bindEvents();

  }
  onUnload() {
    this.delegateElement.off();
    document.removeEventListener("product:added", this.onProductAddedListener);
  }
  bindEvents() {
    if (window.theme.listener == "false") {
      this.onProductAddedListener = this.onProductAdded.bind(this);
      document.addEventListener("cart-drawer:open", this.onOpen.bind(this));
      document.addEventListener("product:added", this.onProductAddedListener);
      this.delegateElement.on(
        "click",
        '[data-action="update-item-quantity"], [data-action="remove-item"]',
        this.updateItemQuantity.bind(this)
      );
      this.delegateElement.on(
        "change",
        '[data-action="update-change-quantity"]',
        this.updateItemQuantity.bind(this)
      );

      this.delegateElement.on(
        "keydown",
        '[data-action="update-change-quantity"]',
        this.preventEvent.bind(this)
      );

      this.delegateElement.on(
        "quantity:changed",
        ".QuantitySelector__CurrentQuantity",
        this.updateItemQuantity.bind(this)
      );
      document.addEventListener("cart:rerender", this.renderCart.bind(this));

      window.theme.listener = "true";
    }
  }

  preventEvent(event, target) {
    if (event.which === 13 || event.keyCode === 13) {
      event.preventDefault();
      this.updateItemQuantity(event, target);
    }
  }

  onOpen() {
    // Get the value of the aria-expanded attribute.
    const isExpanded = this.element.getAttribute("aria-expanded") === "true";


    // Early exit if the drawer is already expanded.
    if (isExpanded) {
      return;
    }

    // Load recommendations if the option is enabled.
    if (this.options.showRecommendations && firstOpen == false) {
      this.loadRecommendations();
      this.loadedOnOpen = true;
    }
    firstOpen = false;
    // Calculate the height of the cart header and free shipping elements.
    const cartHeader = document.querySelector(".CartHeader");

    const cartHeaderHeight = cartHeader ? cartHeader.offsetHeight : 0;

    let totalHeight = cartHeaderHeight;

    // Set the height of the cart header using a CSS variable.
    /* if(window.theme.cartCount > 0 ){
       totalHeight = cartHeaderHeight;
    }  */
    document.documentElement.style.setProperty(
      "--cartHeader-height",
      totalHeight + "px"
    );

  }

  updateItemQuantity(event, target) {
    event.preventDefault();
    target
      .closest(".cartItem")
      .querySelector(".itemLoader")
      .classList.add("is-visible");
    var _this = this;

    var quantity = null;
    if (target.tagName === "INPUT") {
      quantity = parseInt(Math.max(parseInt(target.value) || 0, 0));
    } else {
      quantity = parseInt(target.getAttribute("data-quantity"));
    }

    let quantityChange = true;
    if (quantity == 0) {
      quantityChange = false;
    }

    fetch(window.routes.localeRootUrl + "/cart/change.js", {
      body: JSON.stringify({
        id: target.getAttribute("data-line-id"),
        quantity: quantity,
      }),
      credentials: "same-origin",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
    }).then(function () {
      _this.renderCart(target.getAttribute("data-id"), quantityChange);
    });
  }

  onProductAdded() {
    var _this = this;
    this.firstProductAdded = false;
    this.renderCart().then(function () {
      _this.sidebarDrawer.openDrawer();
    });
  }

  renderCart(lineNumber, quantityChange) {
    firstOpen = false;
    this.pageLoader.style.width = 100 + "%";
    let skipEvent = false;
    if (event && event.type == "cart:rerender") {
      lineNumber = "CartItem-" + event.detail.lineItem;
      quantityChange = event.detail.quantityChange;
      skipEvent = true;
    }
    var _this = this;
    return fetch(

      window.routes.localeRootUrl + "/?section_id=main-cart_drawer",

      {
        credentials: "same-origin",
        method: "GET",
      }
    ).then(function (content) {
      content.text().then(function (html) {
        _this.replaceContent(html, lineNumber, quantityChange, skipEvent);
      });
    });

  }

  replaceContent(html, lineNumber, quantityChange, skipEvent) {
    var _this = this;
    this.pageLoader.style.left = "unset";
    this.pageLoader.style.right = 0 + "px";
    this.pageLoader.style.width = 0 + "%";
    setTimeout(() => {
      this.pageLoader.style.left = 0 + "px";
      this.pageLoader.style.right = "unset";
    }, 550);

    var tempElement = new DOMParser().parseFromString(html, "text/html");

    this.tempOptions = JSON.parse(
      tempElement.querySelector("#cart").getAttribute("data-settings")
    );

    this.options = this.tempOptions;

    if (this.firstProductAdded) document.dispatchEvent(_this.changeEvent);
    this.firstProductAdded = true;

    var number = this.tempOptions["itemCount"];
    this.cartCount.innerHTML = `${number}`;

    window.theme.cartCount = parseInt(number);
    if (lineNumber && tempElement.querySelector("#" + lineNumber)) {
      var cartNodeParent = this.element.querySelector("#" + lineNumber);
      const itemToReplaceWith = tempElement.querySelector(
        "#" + lineNumber + " .cartItem--Informations"
      );
      if (cartNodeParent && cartNodeParent.querySelector(".itemLoader")) {
        cartNodeParent
          .querySelector(".itemLoader")
          .classList.remove("is-visible");
      }
      if (itemToReplaceWith) {
        cartNodeParent.replaceChild(
          itemToReplaceWith,
          cartNodeParent.querySelector(".cartItem--Informations")
        );
      } else {
        cartNodeParent.classList.add("removing");
        cartNodeParent.animate(
          [
            // keyframes
            { transform: "translateY(0px)", opacity: "1" },
            { transform: "translateY(30px)", opacity: "0" },
          ],
          {
            // timing options
            duration: 500,
            fill: "forwards",
          }
        );
        setTimeout(() => {
          cartNodeParent.remove();
        }, 500);

        if (this.options["showRecommendations"]) {
          this.loadRecommendations();
        }
      }

      if (number > 0) {
        const footerTotal = this.element.querySelector(".CartFooter--Total");
        const footerTotalsToReplace =
          tempElement.querySelector(".CartFooter--Total");
        const footerTotalsParent = this.element.querySelector(
          ".CartFooter--Totals"
        );
        if (footerTotalsParent) {
          footerTotalsParent.replaceChild(footerTotalsToReplace, footerTotal);
        }

        const cartFreeShippingParent = this.element.querySelector(
          ".cartDrawer--freeShipping"
        );
        const cartFreeShippingToReplace = tempElement.querySelector(
          ".cartDrawer--freeShippingLeftContent"
        );

        const shippingBarTemp = tempElement.querySelector(
          ".cartDrawer--freeShippingLeftMoneyProgress"
        );
        const shippingBarCurrent = this.element.querySelector(
          ".cartDrawer--freeShippingLeftMoneyProgress"
        );

        if (cartFreeShippingToReplace) {
          cartFreeShippingParent.replaceChild(
            cartFreeShippingToReplace,
            cartFreeShippingParent.querySelector(
              ".cartDrawer--freeShippingLeftContent"
            )
          );


          if (shippingBarTemp && shippingBarCurrent) {
            shippingBarCurrent.style.width = shippingBarTemp.style.width;
          } else if (shippingBarCurrent && !shippingBarTemp) {
            shippingBarCurrent.remove();
          } else {
            cartFreeShippingParent.append(
              tempElement.querySelector(
                ".cartDrawer--freeShippingLeftMoneyProgressBar"
              )
            );
          }

        }
      } else {
        this.element
          .querySelector(".CartDrawer--Footer")
          .classList.add("removing");
        this.recommendationsLoaded = false;
        const mainPartParent = this.element.querySelector(".CartDrawer");

        mainPartParent.innerHTML =
          tempElement.querySelector(".CartDrawer").innerHTML;

        if (window.theme.enableAnimations) {
          const mainPartchildren =
            mainPartParent.querySelector("#main-cartItems");
          mainPartchildren.animate(
            [
              // keyframes
              { opacity: "0" },
              { opacity: "1" },
            ],
            {
              // timing options
              duration: 500,
              fill: "forwards",
            }
          );
        }
      }
      if (this.element.querySelector(".itemLoader")) {
        setTimeout(() => {
          this.element
            .querySelector(".itemLoader")
            .classList.remove("is-visible");
        }, 250);
      }
    } else {
      const cartNodeParent =
        this.element.querySelector(".CartDrawer").parentNode;
      const currentScrollPosition =
        this.element.querySelector("#main-cartItems").scrollTop;

      cartNodeParent.replaceChild(
        tempElement.querySelector(".CartDrawer"),
        this.element.querySelector(".CartDrawer")
      );
      this.element.querySelector("#main-cartItems").scrollTop =
        currentScrollPosition;
    }

    if (window.theme.enableAnimations) {
      new RevolutionAnimation(this.element);
    }



    setTimeout(() => {
      if (this.options["showRecommendations"] && !quantityChange) {
        if (this.loadedOnOpen == false) {
          this.loadRecommendations();
        }
        this.loadedOnOpen = false;

        this.element.dispatchEvent(
          new CustomEvent("cart:rerendered", { bubbles: true })
        );
      }
      if (!skipEvent) {
        var focus = _this.element.querySelector("[data-scrollable]");
        bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
      }
      _this.sidebarDrawer.maxHeight();
    }, 200);
  }

  loadRecommendations() {
    const _this = this;

    // Determine the URL to fetch recommendations based on the product ID option.
    const productId = this.options.productId;
    const url = productId
      ? `${window.routes.localeRootUrl}/recommendations/products?section_id=helper-recommendations&product_id=${productId}&limit=10`
      : "?section_id=helper-recommendations";

    // Fetch the recommendations and parse the HTML content.
    fetch(url)
      .then(function (response) {
        return response.text();
      })
      .then(function (content) {
        const container = document.createElement("div");
        container.innerHTML = content;

        // Insert the recommendations HTML into the recommendations container.
        const upsellContainer = container.querySelector(".cartUpsell");
        const recommendationsContainer = document.querySelector(
          ".cartRecommendations"
        );

        recommendationsContainer.innerHTML = upsellContainer.innerHTML;


        // Initialize the Swiper instance with the recommendations container and options.
        const swiper = new Swiper(
          recommendationsContainer.querySelector(".swiperUpsell"),
          {
            slidesPerView: 2,

            spaceBetween: 16,
            slidesOffsetAfter: 0,
            slidesOffsetBefore: 0,
            resistanceRatio: 0,
            loop: false,
            allowTouchMove: true,
            mousewheel: {
              forceToAxis: true,
            },
            navigation: {
              nextEl: ".swiperNextCart",
              prevEl: ".swiperButtonPrevious",
            },
            breakpoints: {
              1025: {
                slidesPerView: 3,
                spaceBetween: 16,
                slidesOffsetAfter: 0,
                slidesOffsetBefore: 0,
              },
            },

          }
        );

        _this.recommendationsLoaded = true;
        // Dispatch a custom event to toggle favorites state.

        // Show the recommendations section and run the Revolution animation if enabled.

        const recommendationsSection = document.querySelector(
          ".cartRecommendations"
        );
        recommendationsSection.style.display = "flex";

        const cartDrawerRecommendation = document.querySelector(
          ".cartRecommendations"
        );

        let cartDrawerSlidesRecommendation = document.querySelectorAll(
          ".cartRecommendations .cartSlideItem"
        );
        if (cartDrawerSlidesRecommendation.length === 0) {
          cartDrawerRecommendation.style.display = "none";

        }

      })
      .catch(function (error) {
        // Handle the error gracefully by logging it or displaying an error message to the user.
        // For this implementation, we will not output errors to the console.
        // Instead, we can display an error message in the UI or send the error to a monitoring service.
      });
  }
}
customElements.define("cart-drawer", CartDrawer);

class FeaturedCollectionSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.domDelegate = new Delegate(this.element);
    this.carouselElement = this.element.querySelector(".swiper");
    this.carousel = new RevolutionSwiper(this.carouselElement);

    this.bindEvents();


  }

  bindEvents() {
    this.isPageLoaded =
      document.readyState === "complete" ||
      document.readyState === "loaded" ||
      document.readyState === "interactive";
    if (!this.isPageLoaded) {
      window.addEventListener("load", this.onPageLoaded.bind(this));
    } else {
      this.onPageLoaded();
    }
  }

  onPageLoaded() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      if (!this.carousel) {
        observer.unobserve(this);
      }
      this.carousel = new RevolutionSwiper(this.carouselElement);
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "-100px 0px 200px 0px",
    }).observe(this);
  }
}
customElements.define("featured-collection", FeaturedCollectionSection);

class SliderTextSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.carouselElement = this.element.querySelector(".swiper");
    this.carousel = new RevolutionSwiper(this.carouselElement);
  }
}
customElements.define("slider-text", SliderTextSection);

class Banner extends HTMLElement {
  constructor() {
    super();
    this.element = this;

    this.pageOverlayElement = document.querySelector(".pageOverlay");
    this.carouselElement = this.element.querySelector("[data-swiper-settings]");
    this.delegateBody = new Delegate(document.body);

    this.options = JSON.parse(
      this.element.getAttribute("data-section-settings")
    );
    this.delegateElement = new Delegate(this.element);
    if (this.options["numberOfSlides"] > 1) {
      this.carousel = new RevolutionSwiper(this.carouselElement);
      this.onImagesReady = this.createObserver.bind(this);
      this.element.addEventListener("swiper:slide-changed", this.onImagesReady);
      this.createObserver();
    } else {
      this.createObserver();
    }
  }

  createObserver() {
    this.observer = new IntersectionObserver(this.handleIntersect.bind(this), {
      threshold: 0.5,
    });

    const target = this.element;
    this.observer.observe(target);
  }

  handleIntersect(entries) {
    var _this = this;
    entries.forEach((entry) => {
      if (entry.intersectionRatio === 1 || entry.isIntersecting == true) {
        if (_this.options["numberOfSlides"] > 1) {
          _this.changeImageQuality();
        } else {
          _this.changeImageQuality(true);
        }
        _this.observer.unobserve(_this);
      }
    });
  }
  changeImageQuality(singleItem) {
    // Get the current breakpoint.
    const breakpoint = new Responsive().getCurrentBreakpoint();

    let imageContainers;
    // Determine which element(s) to search for based on the singleItem parameter.
    if (singleItem) {
      imageContainers = Array.from(
        this.element.querySelectorAll(".Banner__ImageContainer--Swap")
      );
    } else {
      const currentIndex = this.carousel.swiperElement.activeIndex;
      const cellElement = this.carousel.swiperElement.slides[currentIndex];
      imageContainers = Array.from(
        cellElement.querySelectorAll(".Banner__ImageContainer--Swap")
      );
    }

    // If no image containers are found, return.
    if (imageContainers.length === 0) {
      return;
    }

    // Determine which image to reveal based on the current breakpoint.
    let imageToReveal;
    if (
      breakpoint === "pocket" ||
      breakpoint === "phone" ||
      breakpoint === "tablet"
    ) {
      imageToReveal = imageContainers[0].querySelector(".Banner__Image");
    } else {
      if (imageContainers.length == 2) {
        imageToReveal = imageContainers[1].querySelector(".Banner__Image");
      } else {
        imageToReveal = imageContainers[0].querySelector(".Banner__Image");
      }
    }

    // If the image to reveal is not found or has already been loaded, return.
    if (!imageToReveal || imageToReveal.dataset.loadedImage === "true") {
      return;
    }
    // Replace the image URL with a higher quality version.
  }
}
customElements.define("banner-hero", Banner);

class Header extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.options = JSON.parse(this.getAttribute("data-settings"));
    this.parentHeader = this.element.closest('.shopify-section');
    this.scrollableElement = this.element.querySelector('[data-scrollable]');
    this.lastScrollPosition = window.pageYOffset;
    if (this.element.classList.contains('Header--Transparent')) {

      this.headerTransparent = true;
    }

    const selectBoxes = this.element.querySelectorAll(".RevolutionSelectbox");
    if (selectBoxes.length > 0) {
      selectBoxes.forEach((item, i) => {
        new RevolutionSelectbox(item);
      });
    }


    if (this.options.sticky) {
      this.toggleSticky();
    }

    document.documentElement.style.setProperty(
      "--header-height-fixed",
      document.querySelector("#header").offsetHeight + "px"
    );


    this.updateVisibleHeight();
    this.bindEvents();


  }

  updateVisibleHeight() {
    setTimeout(() => {
      const rect = this.element.getBoundingClientRect();
      const windowHeight = window.innerHeight;

      // Calculate the visible height
      let visibleHeight =
        Math.min(rect.bottom, windowHeight) - Math.max(rect.top, 0);

      // Ensure the visibleHeight is never negative
      visibleHeight = Math.max(visibleHeight, 0);
      // Update the height of header with the visible height
      document.documentElement.style.setProperty(
        "--header-dynamic-height",
        `${visibleHeight}px`
      );

      document.documentElement.style.setProperty(
        "--header-height-fixed",
        document.querySelector("#header").offsetHeight + "px"
      );
    }, 250);
  }


  toggleSticky() {
    this.element.parentElement.classList.add("header--Sticky");
    this.element.parentElement.classList.remove("Header--Transparent");
  }


  bindEvents() {
    // Binding methods and storing references
    this.toggleColorListener = this.toggleColor.bind(this);
    this.toggleTopBarListener = this.toggleTopBar.bind(this);
    this.scrollEventsListener = this.scrollEvents.bind(this);
    this.updateVisibleHeightListener = this.updateVisibleHeight.bind(this);
    this.closeMenuListener = this.closeMenu.bind(this);
    this.openMenuListener = this.openMenu.bind(this);

    // Window event listeners
    window.addEventListener("scroll", this.scrollEventsListener);
    window.addEventListener('resize', this.updateVisibleHeightListener);

    // Delegated event listeners on custom delegateElement
    this.delegateElement.on("mouseenter", "[aria-hasMenu='true']", this.openMenuListener, true);
    this.delegateElement.on("click", ".header--LinkList", this.closeMenuListener, true);
    this.delegateElement.on("focusin", "[aria-hasMenu='true']", this.openMenuListener, true);
    this.delegateElement.on("mouseleave", "[aria-submenu]", this.closeMenuListener, true);
    this.delegateElement.on("mouseenter", "[aria-singlemenu]", this.closeMenuListener, true);
   // this.delegateElement.on("focusin", "[aria-singleMenu], .mainLinks", this.closeMenuListener, true);
  }

  scrollEvents() {
    if (this.options && this.options.sticky) {
      this.toggleTopBarListener();
    }

    this.toggleColorListener();
    this.updateVisibleHeightListener();
  }
  animationHandler() {
    if ((event.animationName == 'slideInMenu' || event.animationName == 'slideOutMenu') && event.type == 'animationstart') {
      this.pointerTarget.style.pointerEvents = "none";
    } else if ((event.animationName == 'slideInMenu' || event.animationName == 'slideOutMenu') && event.type == 'animationend') {
      const allDisabled = this.element.querySelectorAll('.headerLinks--innerWrapper[aria-hasmenu="true"]');
      allDisabled.forEach((item) => {
        item.style.pointerEvents = "all";
      })
    }
  }


  openMenu(event, target) {

    // Dispatch a custom event to indicate that the menu is being opened.
    this.element.dispatchEvent(new CustomEvent('menu:open', { bubbles: true }));

    // If the event is a mouseenter event and the target is not the same as the event target, return.
    if (event.type === 'mouseenter' && target !== event.target) {
      return;
    }

    if (this.options.transparent && this.headerTransparent) {
      this.element.classList.remove("Header--Transparent");
    }

    target.setAttribute('aria-expanded', 'true');
    this.animationStartListener = this.animationHandler.bind(this);
    this.listener = target.parentElement.querySelector('.desktopMenu--Dropdown');
    this.pointerTarget = target.closest('.headerLinks--innerWrapper');
    this.listener.addEventListener("animationstart", this.animationStartListener);
    this.listener.addEventListener("animationend", this.animationStartListener);

    const targetParent = target.closest('.header--Links');
    // Close any siblings of the target element.
    const siblings = Array.from(targetParent.parentElement.children)
                    .filter((child) => child !== targetParent && child.querySelector('.headerLinks--innerWrapper').getAttribute('aria-expanded') === 'true');
    siblings.forEach((item) => item.querySelector('.headerLinks--innerWrapper').setAttribute('aria-expanded', 'false'));

    // Disable body scroll on the scrollable element inside the menu.
    bodyScrollLock.disableBodyScroll(this.scrollableElement, bodyScrollLockOptions);
  }


  closeMenu(event, target) {
  
    if (event.type === "mouseleave" && target !== event.target) { return; }

    this.animationStartListener = this.animationHandler.bind(this);

    const openElement = this.element.querySelector('[aria-expanded="true"]');
    if(!openElement) return;
    this.listener = openElement.querySelector('.desktopMenu--Dropdown');
    if(!this.listener) return;
    this.pointerTarget = openElement;
    this.listener.addEventListener("animationstart", this.animationStartListener);
    this.listener.addEventListener("animationend", this.animationStartListener);

    openElement.setAttribute("aria-expanded", "false");
  
    if(!event.target.classList.contains('searchItem') && !event.target.classList.contains('RevolutionSelectbox--Title')){
      setTimeout(() => {
     
        this.toggleColor();
      }, 600);
    } 


    bodyScrollLock.enableBodyScroll(this.scrollableElement);
  }



  toggleColor() {


    const currentScrollPosition = window.pageYOffset;
    // Only add 'Header--Scrolled' if scrolling up and past a certain point
    if (currentScrollPosition < this.lastScrollPosition && currentScrollPosition > 125) {
      this.element.classList.add('Header--Scrolled');
    } else {
      this.element.classList.remove('Header--Scrolled');
    }
    // Transparent header adjustments
    if (this.options.transparent && this.headerTransparent) {
      if (currentScrollPosition > 125 && currentScrollPosition <= this.lastScrollPosition && this.options.sticky) {
        // Only remove "Header--Transparent" when scrolling up
        this.element.classList.remove("Header--Transparent");
      } else if (currentScrollPosition <= 125) {
        // Always add "Header--Transparent" when at the top of the page
        this.element.classList.add("Header--Transparent");
      }
    }

    // Update the last scroll position to current for the next event
    this.lastScrollPosition = currentScrollPosition;
  }
  toggleTopBar() {


    let current = window.scrollY;


    if (100 < current) {
      this.element.parentElement.classList.add("header--fixed-top-bar");

    }

    if (current <= 100) {
      this.element.parentElement.classList.remove("header--fixed-top-bar");
    }

    if (
      this.prevOffset < current &&
      current >= 100
    ) {
      this.element.parentElement.classList.add("header--hide");
      document.documentElement.style.setProperty(
        "--header-dynamic-height",
        `0px`
      );
    } else {
      this.element.parentElement.classList.remove("header--hide");
      this.updateVisibleHeight();
    }

    this.prevOffset = current;
  }

}
customElements.define("header-component", Header);



class MainMenuDropdown extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.isOpen = false;
    new Drawer(this.element);

    this.bindEvents();
  }
  bindEvents() {

    this.closeAllInnerElementsListener = this.closeAllInnerElements.bind(this);
    document.addEventListener("menuDrawer:closed", this.closeAllInnerElementsListener);

    this.delegateElement.on(
      "click",
      '[data-action="toggle-subdrawer"]',
      this.toggleNextElement.bind(this)
    );

    this.delegateElement.on(
      "click",
      '[data-action="toggle-prev-subdrawer"]',
      this.togglePreviusElement.bind(this)
    );
  }

  toggleNextElement(event, target) {

    if (this.isOpen) return;
    this.isOpen = true;
    event.preventDefault();
    let nextEl = target.getAttribute("data-toggle-id"),
      subdrawer = this.element.querySelector("#" + nextEl);

    subdrawer.style.display = 'block';

    setTimeout(() => {
      subdrawer.setAttribute("aria-expanded", "true");
      const focus = subdrawer.querySelector('[data-scrollable]');
      bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
    }, 15);


  }

  togglePreviusElement(event, target) {
    if (!this.isOpen) return;
    event.preventDefault();

    this.subdrawer = target.closest(".second-level__drawer");
    this.subdrawer.setAttribute("aria-expanded", "false");
    const focus = this.subdrawer.querySelector('[data-scrollable]');
    bodyScrollLock.enableBodyScroll(focus);
    this.transitionEndedListener = this.translateTransitionEnded.bind(this);
    this.subdrawer.addEventListener("transitionend", this.transitionEndedListener);
  }


  translateTransitionEnded() {
    if (event.propertyName == 'transform') {
      this.isOpen = false;
      this.subdrawer.style.display = 'none';
      this.subdrawer.removeEventListener("transitionend", this.transitionEndedListener);
    }
  }

  closeAllInnerElements() {

    this.element
      .querySelectorAll(".second-level__drawer")
      .forEach((item) => {
        item.setAttribute("aria-hidden", "true");
        item.style.display = "none";
      });
    this.isOpen = false;
    bodyScrollLock.clearAllBodyScrollLocks();


  }
}

customElements.define("main-menu-dropdown", MainMenuDropdown);

class Transition {
  constructor() {
    this.pageOverlay = document.querySelector(".pageTransition");

    if (!this.isPageLoaded) {
      document.addEventListener(
        "DOMContentLoaded",
        this.onPageLoaded.bind(this)
      );
    } else {
      this.onPageLoaded();
    }
  }

  onPageLoaded() {
    this.isPageLoaded = true;
    if (this.pageOverlay && window.theme.showPageTransition) {
      this.pageOverlay.animate([{ opacity: 1 }, { opacity: 0 }], {
        duration: 100,
        fill: "forwards",
        easing: "ease-in-out",
        iterations: 1,
      });
    }
  }

  onPageUnload(event, target) {
    if (
      event.defaultPrevented ||
      event.ctrlKey ||
      event.metaKey ||
      !window.theme.showPageTransition ||
      !this.pageOverlay
    ) {
      return;
    }

    event.preventDefault(); // Prevent the click to happen

    if (this.pageOverlay) {
      var timeline = new TimelineLite({
        onComplete: function onComplete() {
          window.location.href = target.href;
        },
      });

      timeline.fromTo(
        this.pageOverlay,
        0.25,
        { autoAlpha: 0, ease: Linear.easeNone },
        { autoAlpha: 1, ease: Linear.easeNone }
      );
    }
  }
}
new Transition();

class VideoComponent extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.options = JSON.parse(
      this.element.getAttribute("data-section-settings")
    );
    this.trueObserver = false;

    if (this.options["using_fade"] == "fade") {
      if (
        this.element.dataset.position == 0 ||
        this.element
          .closest(".swiper-slide")
          .classList.contains("swiper-slide-active") ||
        this.element
          .closest(".swiper-slide")
          .classList.contains("swiper-slide-duplicate-active")
      ) {
        this.checkLoaded();
        this.bindEvents();
      } else {
        this.bindEvents();
      }
    } else {
      this.checkLoaded();
    }
  }

  bindEvents() {
    window.removeEventListener(
      "swiper:slide-changed",
      this.onSlideChangeListener
    );
    this.onSlideChangeListener = this.onSlideChange.bind(this);
    window.addEventListener("swiper:slide-changed", this.onSlideChangeListener);
  }

  checkLoaded() {
    var _this = this;
    if (typeof videojs !== "undefined") {
      this.videoPlayerInitialization();
    } else {
      loadScript(window.theme.videoScript);
      setTimeout(function () {
        _this.checkLoaded();
      }, 100);
    }
  }

  onSlideChange(event) {
    this.elementPosition = parseInt(this.element.getAttribute("data-position"));
    if (event.detail.currentIndex == this.elementPosition) {
      if (!this.element.getAttribute("loaded")) {
        var node = document.createElement("div");
        node.appendChild(
          this.element
            .querySelector("template")
            .content.firstElementChild.cloneNode(true)
        );
        this.element.appendChild(node.firstElementChild).focus();
        this.element.setAttribute("loaded", true);
        if (!this.videoPlayer) {
          this.checkLoaded();
        } else {
          if (this.options["viewport"]) {
            this.videoPlayer.play();
            this.createObserver();
          }
        }
      } else {
        if (!this.videoPlayer) {
          this.checkLoaded();
        } else {
          if (this.options["viewport"]) {
            this.videoPlayer.play();
            this.createObserver();
          }
        }
      }
    } else if (
      this.videoPlayer &&
      this.videoPlayer.el_.classList.contains("vjs-playing")
    ) {
      this.videoPlayer.pause();
    }
  }

  videoPlayerInitialization() {
    if (!this.element.getAttribute("loaded")) {
      const node = document.createElement("div");
      node.appendChild(
        this.element
          .querySelector("template")
          .content.firstElementChild.cloneNode(true)
      );
      this.element.appendChild(node.firstElementChild).focus();
      this.element.setAttribute("loaded", true);
    }

    const responsive = new Responsive();
    const breakpoint = responsive.getCurrentBreakpoint();
    const isMobile = breakpoint === "phone" || breakpoint === "tablet";

    let aspect_ratio = "";
    let src = "";
    let host = "html5";

    if (isMobile) {
      aspect_ratio = this.options["aspect_mob"] || "9:16";

      if (this.options["videoType"] == "video_inside_media") {
        const sources = this.options["videod"]["sources"];
        let topQuality = null;
        sources.forEach((obj) => {
          if (obj.format === "mp4") {
            if (!topQuality) topQuality = obj;
            if (topQuality.height < obj.height) topQuality = obj;
          }
        });
        const aspectRatioHeight = Math.floor(
          100 / this.options["videod"]["aspect_ratio"]
        );
        if (!this.options["videoRatio"]) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        }
        src = topQuality["url"] + "#t=0.001";
      } else if (this.options["videoType"] == "video_inside_media_external") {
        const aspectRatioHeight = Math.floor(
          100 / this.options["videom"]["aspect_ratio"]
        );
        if (!this.options["videoRatio"]) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        }
        host = this.options["videom"]["host"];
        if (host == "youtube") {
          src =
            "https://www.youtube.com/watch?v=" +
            this.options["videom"]["external_id"];
        } else {
          src = this.options["videom"]["external_id"];
        }
      } else {
        if (this.options["videom"].includes("youtube")) {
          host = "youtube";
        } else if (this.options["videom"].includes("vimeo")) {
          host = "vimeo";
        }
        src = this.options["videom"];
      }
    } else {
      aspect_ratio = this.options["aspect_desk"] || "16:9";

      if (this.options["videoType"] == "video_inside_media") {
        const sources = this.options["videod"]["sources"];
        let topQuality = null;
        sources.forEach((obj) => {
          if (obj.format === "mp4") {
            if (!topQuality) topQuality = obj;
            if (topQuality.height < obj.height) topQuality = obj;
          }
        });
        src = topQuality["url"] + "#t=0.001";
        const aspectRatioHeight = Math.floor(
          100 / this.options["videod"]["aspect_ratio"]
        );

        if (!this.options["videoRatio"]) {

          aspect_ratio = `100:${aspectRatioHeight}`;
        }
      } else if (this.options["videoType"] == "video_inside_media_external") {
        host = this.options["videod"]["host"];
        const aspectRatioHeight = Math.floor(
          100 / this.options["videod"]["aspect_ratio"]
        );
        if (!this.options["videoRatio"]) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        }
        if (host == "youtube") {
          src =
            "https://www.youtube.com/watch?v=" +
            this.options["videod"]["external_id"];
        } else {
          src = this.options["videod"]["external_id"];
        }
      } else {
        if (this.options["videod"].includes("youtube")) {
          host = "youtube";
        } else if (this.options["videod"].includes("vimeo")) {
          host = "vimeo";
        }
        src = this.options["videod"];
      }
    }
    if (!src) {
      src = "https://www.youtube.com/watch?v=_9VUPq3SxOc";
      host = "youtube";
    }
    const type =
      host === "youtube"
        ? "video/youtube"
        : host === "vimeo"


          ? "video/vimeo"
          : "video/mp4";


    aspect_ratio = aspect_ratio.replace("/", ":");
    const payload = {
      aspectRatio: aspect_ratio,
      autoplay: false,
      muted: this.options["muted"],
      loop: this.options["loop"],
      controls: this.options["controls"],
      poster: false,
      preload: "metadata",
      playsinline: true,
      responsive: true,
      techOrder: [host],
      disablePictureInPicture: true,
      controlBar: {
        children: [
          "playToggle",
          "progressControl",
          "currentTimeDisplay",
          "timeDivider",
          "durationDisplay",
          "CustomControlSpacer",
          "VolumePanel",
          "fullscreenToggle",
        ],
      },

      sources: [
        {
          type: type,
          src: src,
        },
      ],
    };

    const videoplayerID = this.element.querySelector("video");
    this.videoPlayer = videojs(videoplayerID, payload);

    const _this = this;
    this.videoPlayer.on("ready", function () {
      _this.element.querySelector(".videoHolder").style.display = "block";

      if (_this.trueObserver == false && _this.options["viewport"]) {
        _this.createObserver();
      }
    });


    if (this.options["muted"] && host == "vimeo") {
      this.videoPlayer.on("play", function () {
        _this.videoPlayer.muted("true");
      });
    }

    if (this.options["controls"]) {


      if (host == "html5") {
        this.videoPlayer.on("touchstart", function () {
          if (event.target.closest(".vjs-control-bar")) {
            return;
          }

          if (_this.videoPlayer.paused()) {
            _this.videoPlayer.play();
          } else {
            _this.videoPlayer.pause();
          }
        });
      }
      if (host == "html5") return;
      this.videoPlayer.on("click", function () {

        if (event.target.closest(".vjs-control-bar")) {
          return;
        }

        if (_this.videoPlayer.paused()) {
          _this.videoPlayer.play();
        } else {
          _this.videoPlayer.pause();
        }
      });
    }
  }

  createObserver() {
    const observer = new IntersectionObserver(this.handleIntersect.bind(this), {
      threshold: 0.2,
      rootMargin: "200px 0px 200px 0px",
    });

    observer.observe(this.element);
    this.trueObserver = true;
  }

  handleIntersect(entries) {
    entries.forEach((entry) => {
      if (entry.intersectionRatio === 1 || entry.isIntersecting == true) {
        if (!this.videoPlayer) {
          this.checkLoaded();
          return;
        }

        if (this.options["viewport"] && this.videoPlayer) {
          if (this.options["muted"]) {
            this.videoPlayer.muted("true");
          }
          const checkIfPlaying = () => {
            if (!this.videoPlayer.el_.classList.contains("vjs-playing")) {
              this.videoPlayer.play();
              setTimeout(checkIfPlaying, 100); // Wait 100 milliseconds and check again
            }
          };

          checkIfPlaying();
        }
      } else if (
        entry.intersectionRatio === 0 ||
        entry.isIntersecting == false
      ) {
        if (
          this.videoPlayer &&
          this.videoPlayer.el_.classList.contains("vjs-playing")
        ) {
          this.videoPlayer.pause();
        }
      }
    });
  }
}
customElements.define("video-component", VideoComponent);

class FooterComponent extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    let responsive = new Responsive();
    let breakpoint = responsive.getCurrentBreakpoint();
    if (breakpoint == "phone" || breakpoint == "tablet") {
      // this.dropdown = new Dropdown(this.element);
    }
  }
}
customElements.define("footer-component", FooterComponent);

class ProductElement extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.domDelegate = new Delegate(this.element);
    this.carouselElement = this.element.querySelector(".mainSwiper");
    this.pageOverlayElement = document.querySelector(".pageOverlay");
    this.notifyMeOverlay = this.element.querySelector(".notifyMeOverlay");
    this.seeMoreButton = this.element.querySelector(".Product--SeeMore");

    this.options = JSON.parse(
      this.element.getAttribute("data-section-settings")
    );

    if (new Responsive().matchesBreakpoint("lap-and-up")) {
      if (this.seeMoreButton) {
        this.domDelegate.on("click", '[data-action="show-more"]', () => {
          this.element
            .querySelectorAll(".swiper-slide.not_desktop")
            .forEach((slide) => slide.classList.remove("not_desktop"));
          this.seeMoreButton.style.display = "none";
        });
      }
    } else {
      if (this.options["slides_number"] > 1) {
        this.carousel = new RevolutionSwiper(this.carouselElement, null, true);

        const pagination = this.element.querySelector(
          ".product-swiper-pagination"
        );
        if (this.options["video_controls"] && pagination) {
          this.carouselElement.swiper.on("slideChange", () => {
            if (
              this.carouselElement.swiper.slides[
                this.carouselElement.swiper.activeIndex
              ].querySelector("video-component")
            ) {
              pagination.style.opacity = "0";
              pagination.style.pointerEvents = "none";
            } else {
              pagination.style.opacity = "1";
              pagination.style.pointerEvents = "";
            }
          });
        }
      }
    }

    this.changeImageQuality();
    this.valuesWrap = this.element.querySelectorAll(
      ".ProductOption--ValusWrapper"
    );
    var localPickup = this.element.querySelector("#LocalPickup");
    if (localPickup) {
      new Drawer(this.querySelector("#LocalPickup"));
    }


    if (this.options["enable_zoom"]) {
      new RevolutionImageZoom(this.element, this.carousel);
    }

    var selectBoxes = this.element.querySelectorAll(".RevolutionSelectbox");

    if (selectBoxes.length > 0) {
      selectBoxes.forEach((item, i) => {
        new RevolutionSelectbox(item);
      });
    }

    if (
      this.options["variant_image_id"] &&
      this.options["show_variant_image_on_load"] &&
      !new Responsive().matchesBreakpoint("lap-and-up")
    ) {
      this.updateImage();
    }

    const ratingsLink = this.element.querySelector(".ProductInfo--RatingsLink");
    const targetElem = document.querySelector("#judgeme_product_reviews");
    if (ratingsLink) {
      if (ratingsLink.href || targetElem) {
        ratingsLink.style.cursor = "pointer";
        ratingsLink.classList.add("underline");
      } else {
        ratingsLink.style.cursor = "default";
      }
      if (targetElem) {
        this.domDelegate.on("click", '[data-action="scroll"]', (e) => {
          e.preventDefault();
          targetElem.scrollIntoView({ behavior: "smooth" });
        });
      }
    }

    if (this.options["sticky_atc"]) {
      this.elementToHide = this.element.querySelector(
        ".ProductAction--StickyATC"
      );
      this.elementToHide.classList.remove("show");

      this.atc = this.element.querySelector(".ScrollToATC");
      this.footer = document.querySelector("#shopify-section-main-footer");

      this.showStickyAtc();
      window.addEventListener('scroll', this.showStickyAtc.bind(this));
    }

    this.bindEvents();
  }

  bindEvents() {
    if (!new Responsive().matchesBreakpoint("lap-and-up")) {
      this.domDelegate.on("variant:changed", this.updateImage.bind(this));
    }
    window.onload = this.showNotifyMeButtons();

    this.domDelegate.on(
      "click",
      '[data-action="notify-open"]',
      this.openNotifyPopup.bind(this)
    );

    this.closeNotifyPopupBinder = this.closeNotifyPopup.bind(this);
  }

  openNotifyPopup() {
    event.preventDefault();
  }

  showNotifyMeButtons() {
    const intervalId = setInterval(() => {
      this.notifyMePopup = document.querySelector(
        ".appikon-bis-inline-form-wrapper"
      );

      if (this.notifyMePopup) {
        clearInterval(intervalId);

        const productImage = this.element
          .querySelector(".back-in-stock__image-wrapper")
          .cloneNode(true);

        productImage.style.display = "";
        const destContainer = this.element.querySelector(
          "#appikon-bis-inline-form-wrapper"
        );
        destContainer.appendChild(productImage);

        const closeButton = document.createElement("button");
        closeButton.classList.add("notifyMe--Close");
        closeButton.setAttribute("data-action", "notify-close");
        closeButton.innerHTML = `
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M10.9978 9.96635L15.9478 5.01636C16.1785 4.74696 16.163 4.34537 15.9122 4.09456C15.6614 3.84375 15.2598 3.82824 14.9904 4.05895L10.0404 9.00894L5.09045 4.05216C4.82104 3.82145 4.41945 3.83696 4.16865 4.08777C3.91784 4.33858 3.90233 4.74017 4.13304 5.00957L9.08303 9.96635L4.12625 14.9163C3.93248 15.0823 3.84807 15.3428 3.90774 15.5909C3.9674 15.8389 4.16107 16.0326 4.40911 16.0923C4.65716 16.1519 4.91771 16.0675 5.08366 15.8737L10.0404 10.9238L14.9904 15.8737C15.2598 16.1045 15.6614 16.0889 15.9122 15.8381C16.163 15.5873 16.1785 15.1857 15.9478 14.9163L10.9978 9.96635Z" fill="#555555"/>
          </svg>`;
        destContainer.appendChild(closeButton);

        const buttonSvg = `
        <svg class="ml-m" xmlns="http://www.w3.org/2000/svg" width="15" height="14" viewBox="0 0 15 14" fill="none">
        <path d="M3.58382 0.000183105L3.62203 1.87231L11.1105 2.02513L0.5 12.6357L1.86452 14.0002L12.475 3.38966L12.6279 10.8782L14.5 10.9164V0.000183105H3.58382Z" fill="white"/>
        </svg>`;

        const subscribeButton = this.notifyMePopup.querySelector("#appikon-bis-inline-form-submit");
        subscribeButton.innerHTML = subscribeButton.innerHTML + buttonSvg;

        this.pageOverlayElement.addEventListener(
          "click",
          this.closeNotifyPopup.bind(this)
        );

        this.domDelegate.on(
          "click",
          '[data-action="notify-open"]',
          this.openNotifyPopup.bind(this)
        );

        this.domDelegate.on(
          "click",
          '[data-action="notify-close"]',
          this.closeNotifyPopup.bind(this)
        );

        if (this.element.querySelector("variant-selects")) {
          this.element.dispatchEvent(
            new CustomEvent("notify:added", {
              bubbles: true,
              detail: this.element.querySelectorAll(".ProductPage--NotifyMe"),
            })
          );
        }
      }
    }, 100);

    setTimeout(() => {
      clearInterval(intervalId);
    }, 10000);
  }

  showStickyAtc() {
    if ((window.scrollY + window.innerHeight < this.footer.getBoundingClientRect().top + window.scrollY) &&
      (window.scrollY > this.atc.getBoundingClientRect().bottom + window.scrollY)) {
      this.elementToHide.classList.add('show');
    } else {
      this.elementToHide.classList.remove('show');
    }
  }

  openNotifyPopup() {
    event.preventDefault();
    this.isOpen = true;

    this.notifyMeOverlay.classList.add("is-visible");
    this.domDelegate.on(
      "click",
      ".notifyMeOverlay",
      this.closeNotifyPopupBinder
    );
    bodyScrollLock.disableBodyScroll(
      document.querySelector("[data-scrollable]"),
      bodyScrollLockOptions
    );
    document
      .querySelector(".appikon-bis-inline-form-wrapper")
      .classList.add("showNotifyMe");
  }

  closeNotifyPopup() {
    event.preventDefault();
    if (!this.isOpen) return;

    this.domDelegate.off(
      "click",
      ".notifyMeOverlay",
      this.closeNotifyPopupBinder
    );
    this.notifyMeOverlay.classList.remove("is-visible");

    bodyScrollLock.enableBodyScroll(
      document.querySelector("[data-scrollable]"),
      bodyScrollLockOptions
    );
    document
      .querySelector(".appikon-bis-inline-form-wrapper")
      .classList.remove("showNotifyMe");

    this.isOpen = false;
  }

  updateImage(event) {
    if (event) {
      var imageID = event.detail.new_image;
    } else {
      var imageID = this.options["variant_image_id"];
    }

    var selector = "#Image--" + imageID;
    var imageEl = this.element.querySelector(selector);

    if (imageEl) {
      this.carousel.selectCell(parseInt(imageEl.getAttribute("data-position")));
    }
  }

  changeImageQuality() {
    var imageToReveal = null;
    imageToReveal = this.element.querySelector(".ProductSlider--ImageFirst");
    if (imageToReveal !== null) {
      const replaceUrl = imageToReveal
        .getAttribute("data-src")
        .replace("{width}x", "2600x");
      imageToReveal.src = replaceUrl;
    }
  }
}
customElements.define("product-component", ProductElement);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.type = this.element.getAttribute("data-type");
    this.productID = this.element.getAttribute("data-product-id");
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.atcButtons = document.querySelectorAll(".ProductPage--ATC");
    this.quantityHandler = document.querySelector(
      ".ProductInfo--QuantityButtons .QuantityHandler"
    );

    this.stockInfo = document.querySelector(".ProductInfo--StockInformation");

    this.regularPrice = document.querySelector(
      ".ProductInfo--RegularPrice .changePrice"
    );
    this.compareAtPrice = document.querySelector(
      ".ProductInfo--CompareAtPrice"
    );

    this.firstCall = true;

    this.bindEvents();
    this.onVariantChange();
  }

  bindEvents() {
    this.delegateBody.on("quantity:changed", this.onQuantityChange.bind(this));

    var selectboxes = this.element.querySelectorAll("select, input");
    selectboxes.forEach((item) => {
      item.addEventListener("change", this.onVariantChange.bind(this));
    });

    this.delegateBody.on("notify:added", () =>
      this.showNotifyMeButton(this.currentVariant.available)
    );
  }

  showNotifyMeButton(available) {
    if (event && event.detail) {
      this.showNotifyMeButtons = event.detail;
    }

    if (!this.showNotifyMeButtons) return;

    if (available) {
      this.showNotifyMeButtons.forEach((btn) => (btn.style.display = "none"));
      this.atcButtons.forEach((btn) => (btn.style.display = "flex"));
      if (this.quantityHandler) this.quantityHandler.style.display = "";
    } else {
      this.showNotifyMeButtons.forEach((btn) => (btn.style.display = "flex"));
      this.atcButtons.forEach((btn) => (btn.style.display = "none"));
      if (this.quantityHandler) this.quantityHandler.style.display = "";
    }
  }

  onQuantityChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton();
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton();
    this.updatePickupAvailability();

    this.updateMedia();
    this.updateURL();
    this.updateVariantInput();
    this.renderProductInfo();
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select, input:checked"),
      (select) => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      this.options;
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateStockLabel() {
    if (!this.stockInfo) return;
    if (this.currentVariant.available) {
      this.stockInfo.classList.remove('red_dot');
      this.stockInfo.classList.add('green_dot');
      this.stockInfo.innerHTML = window.variantStrings.inStock;
    } else {
      this.stockInfo.classList.remove('green_dot');
      this.stockInfo.classList.add('red_dot');
      this.stockInfo.innerHTML = window.variantStrings.outOfStock;
    }
  }

  updatePrice() {
    if (this.regularPrice) {
      this.regularPriceTag = this.currentVariant.price;
      this.regularPrice.innerHTML = Shopify.formatMoney(
        this.regularPriceTag,
        window.theme.moneyFormat
      );
    } 
    if (this.compareAtPrice) {
      this.compareAtPriceTag = this.currentVariant.compare_at_price;
      if (this.compareAtPriceTag) {
        this.compareAtPrice.innerHTML = Shopify.formatMoney(
          this.compareAtPriceTag,
          window.theme.moneyFormat
        );
        this.compareAtPrice.style.display = "block";
      } else {
        this.compareAtPrice.innerHTML = "";
        this.compareAtPrice.style.display = "none";
      }
    }
  }

  updateMedia() {
    if (this.firstCall) {
      this.firstCall = false;
      return;
    }
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const newMedia = this.currentVariant.featured_media.id;
    if (!newMedia) return;
    this.element.dispatchEvent(
      new CustomEvent("variant:changed", {
        bubbles: true,
        detail: { new_image: newMedia },
      })
    );
  }

  updateURL() {
    if (!this.currentVariant) return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.productID}, #product-form-installment`
    );

    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  renderProductInfo() {
    this.updatePrice();
    this.updateStockLabel();

    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");

        const quantityButton = document.querySelector(".QuantityHandler");
        if (quantityButton) {
          const source = html.querySelector(".QuantityHandler");
          if (source && quantityButton)
            quantityButton.innerHTML = source.innerHTML;
        }
        this.toggleAddButton();
      });
  }

  toggleAddButton() {
    let quantity = "";
    const addButton = document.querySelectorAll(".ProductPage--ATC"),
      addButtonInner = document.querySelectorAll(
        ".ProductPage--ATC .SelfAlign"
      ),
      quantityEl = document.querySelector(".QuantitySelector__ProductQuantity");
    if (quantityEl) {
      quantity = quantityEl.value;
    }
    if (window.variantInfo?.show_icon) {
      var buySvg =
        '<svg class="Svg Svg--shopping_cart mr-m" width="24" height="24" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M25.31 5.19547C25.1687 5.02127 24.9568 4.91946 24.7325 4.91797H9.11751L9.60501 6.41797H23.75L21.7475 15.418H10.4975L7.07001 4.56547C6.99476 4.33174 6.80986 4.14965 6.57501 4.07797L3.50001 3.13297C3.24278 3.05393 2.96292 3.11812 2.76584 3.30137C2.56877 3.48461 2.48443 3.75907 2.54459 4.02137C2.60476 4.28366 2.80028 4.49393 3.05751 4.57297L5.75001 5.39797L9.19251 16.273L7.96251 17.278L7.86501 17.3755C7.2374 18.0987 7.21221 19.1659 7.80501 19.918C8.21952 20.4221 8.84817 20.7002 9.50001 20.668H22.0175C22.4317 20.668 22.7675 20.3322 22.7675 19.918C22.7675 19.5038 22.4317 19.168 22.0175 19.168H9.38001C9.20436 19.162 9.0446 19.0646 8.95873 18.9113C8.87286 18.7579 8.87334 18.5709 8.96001 18.418L10.7675 16.918H22.3475C22.705 16.9267 23.0189 16.6818 23.0975 16.333L25.475 5.83297C25.5212 5.6064 25.4603 5.37117 25.31 5.19547ZM20.75 25.168C21.682 25.168 22.4375 24.4125 22.4375 23.4805C22.4375 22.5485 21.682 21.793 20.75 21.793C19.818 21.793 19.0625 22.5485 19.0625 23.4805C19.0625 24.4125 19.818 25.168 20.75 25.168ZM12.185 23.4805C12.185 24.4125 11.4295 25.168 10.4975 25.168C9.56553 25.168 8.81001 24.4125 8.81001 23.4805C8.81001 22.5485 9.56553 21.793 10.4975 21.793C11.4295 21.793 12.185 22.5485 12.185 23.4805Z" fill="#121212"></path></svg>';
    } else {
      var buySvg = "";
    }

    if (!addButton) return;
    if (!quantity) {
      quantity = 1;
    }

    if (this.currentVariant.available == false) {
      addButton.forEach((btn) => {
        btn.setAttribute("disabled", "disabled");
        btn.classList.add("ProductCard--Sold__Out");
      });
      addButtonInner.forEach((btn) => {
        btn.innerHTML = buySvg + window.variantStrings.soldOut;
      });
    } else {
      addButton.forEach((btn) => {
        btn.removeAttribute("disabled");
        btn.classList.remove("ProductCard--Sold__Out");
      });
      if (window.variantInfo?.show_price) {
        var priceElement =
          "<span class='u-pb1'>&nbsp;- " +
          Shopify.formatMoney(
            this.currentVariant.price * quantity,
            window.theme.moneyFormat
          ) + "</span>";
      } else {
        var priceElement = "";
      }

      addButtonInner.forEach((btn) => {
        btn.innerHTML = buySvg + window.variantStrings.addToCart + priceElement + `<svg class="ml-m" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.08382 0L3.12203 1.87212L10.6105 2.02495L0 12.6355L1.36452 14L11.975 3.38947L12.1279 10.878L14 10.9162V0H3.08382Z" fill="black"/></svg>`;
      });
    }
    this.showNotifyMeButton(this.currentVariant.available);
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(
        this.querySelector('#general[type="application/json"]').textContent
      );
    return this.variantData;
  }
}
customElements.define("variant-selects", VariantSelects);

class SearchBar extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.searchElement = this;


    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.searchInputElement = this.element.querySelector('[name="q"]');

    this.searchResultsElement = this.element.querySelector(".searchWrapper");
    this.pageOverlayElement = this.element.querySelector(".sectionOverlay");
    this.options = JSON.parse(this.element.getAttribute("data-settings"));
    this.initialSearchLayout = this.searchResultsElement.cloneNode(true);
    this.clearSearchButton = this.element.querySelector(".searchInput--clear");

    this.transitionEndHandlerListener = this.transitionEndHandler.bind(this);
    this.element.addEventListener("transitionend", this.transitionEndHandlerListener);


    if (window.theme.showRecentSearches) {
      this.getRecentSearches();
    }



    if (window.theme.showSuggestedSearches) {
      this.getSuggestedSearches();
    }
    if (document.querySelector(".Header--Transparent")) {

      this.headerTransparent = true;
    }
    this.carouselElement = this.element.querySelector(".searchInitialView");
    if (this.carouselElement) {
      if (new Responsive().matchesBreakpoint("lap-and-up")) {
        this.carousel = new RevolutionSwiper(this.carouselElement);
      }
    }

    if (new Responsive().matchesBreakpoint("pocket")) {
      this.element.querySelector('.searchInnerWrapper').style.height = 'unset';
    }

    document.documentElement.style.setProperty(
      "--search-header-height",
      `${this.searchInputElement.offsetHeight + 48}px`
    );

    this.bindEvents();
  }

  bindEvents() {
    this._onInputListener = this.debounce(this.onInput.bind(this), 450);

    this.delegateBody.on(
      "click",
      '[data-action="open-search"]',
      this.openSearch.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="clear-input"]',
      this.resetSearch.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="close-search"]',
      this.closeSearch.bind(this)
    );

    this.searchInputElement.addEventListener("input", this._onInputListener);

    this.delegateElement.on(
      "click",
      '[data-action="search-string"]',
      this.onInput.bind(this)
    );

    this.delegateElement.on(
      "keypress",
      '[data-action="search-string"]',
      this.onInput.bind(this)
    );
    this.delegateBody.on("menu:open", this.closeSearch.bind(this));
    this.delegateBody.on("close:search", this.closeSearch.bind(this));
  }





  initCarousel() {
    if (new Responsive().matchesBreakpoint("lap-and-up")) {
      var carousel = this.searchResultsElement.querySelector(
        "[data-swiper-settings]"
      );
      if (carousel) {
        this.newCarousel = new RevolutionSwiper(carousel);
      }
    }
  }

  debounce(fn, delay) {
    var _this0 = this;

    var timer = null;

    return function () {
      for (
        var _len = arguments.length, args = Array(_len), _key = 0;
        _key < _len;
        _key++
      ) {
        args[_key] = arguments[_key];
      }

      clearTimeout(timer);

      timer = setTimeout(function () {
        fn.apply(_this0, args);
      }, delay);
    };
  }

  openSearch(event) {
    if (this.isOpen) {
      this.closeSearch();
      return;
    }

    event.preventDefault();
    this.element.removeEventListener(
      "transitionend",
      this.transitionEndHandlerListener
    );
    this.element.style.display = "block";
    const _this = this;
    // Check if search is already open, close it if true



    this.element.dispatchEvent(
      new CustomEvent("menu:close", { bubbles: true })
    );

    this.element.dispatchEvent(
      new CustomEvent("drawer:close-other", { bubbles: true })
    );

    // Check if search element exists
    if (!this.element) {
      console.error("Search element not found");
      return;
    }

    // Show search element and page overlay
    const search = document.querySelector("#quickSearch");
    if (search) {
      if (new Responsive().matchesBreakpoint('phone')) {
        setTimeout(() => {
          this.element.setAttribute("aria-hidden", "false");
        }, 10);
      } else {
        this.element.setAttribute("aria-hidden", "false");
      }


    }
    this.pageOverlayElement.classList.add("is-visible");
    // Disable scrolling on body
    bodyScrollLock.disableBodyScroll(
      this.element.querySelector("[data-scrollable]"),
      bodyScrollLockOptions
    );

    // Focus on search input element after delay
    setTimeout(() => {
      if (_this.searchInputElement) {
        _this.searchInputElement.focus();
      }
    }, 200);


    if (document.querySelector(".Header--Transparent")) {
      setTimeout(() => {
        const header = document.body.querySelector("#header");
        if (header) {
          header.classList.remove("Header--Transparent");
        }
      }, 15);
      this.headerTransparent = true;
    }

    // Set isOpen to true
    this.isOpen = true;

    // Add event listener to page overlay to close search
    if (this.pageOverlayElement) {
      this.closeListener = this.closeSearch.bind(this);
      this.pageOverlayElement.addEventListener("click", this.closeListener);
    }

  }

  closeSearch() {
    event.preventDefault();
    this.eventType = event.type;
    if (!this.isOpen) {
      return;
    }
    bodyScrollLock.enableBodyScroll(
      this.element.querySelector("[data-scrollable]"),
      bodyScrollLockOptions
    );
    this.element.setAttribute("aria-hidden", true);
 
      this.element.addEventListener("transitionend", this.transitionEndHandlerListener);
    

    this.pageOverlayElement.classList.remove("is-visible");


    this.isOpen = false;
  }

  transitionEndHandler() {

    const selectBoxOpen = document.body.querySelector('#header .RevolutionSelectbox--Button[aria-expanded="true"]');
    if (this.headerTransparent && this.eventType != 'menu:open' && !selectBoxOpen) {
     
      document.body
        .querySelector("#header")
        .toggleColor();
    }
    this.eventType = null;
    this.element.style.display = "none";
    this.element.removeEventListener(
      "transitionend",
      this.transitionEndHandlerListener
    );
  }

  async onInput(event) {
    this.allPredictiveSearchInstances = [];
    this.lastInputValue = event.target.value;
    this.searchResultsElement = this.element.querySelector(".searchWrapper");
    this.searchResultsElement.style.opacity = 0;
    this.clearSearchButton.setAttribute("aria-hidden", "false");
    if (event.target.getAttribute("data-value") && this.lastInputValue === 0) {
      this.lastInputValue = event.target.getAttribute("data-value");
      const el = this.element.querySelector(".searchInput");

      el.setAttribute("value", this.lastInputValue);
      el.value = this.lastInputValue;
    } else {
      if (this.lastInputValue === "") {
        this.initialSearchLayout.style.opacity = 0;
        this.resetSearch();
        return;
      }
    }

    try {
      const response = await fetch(
        `${routes.predictive_search_url}?q=${encodeURIComponent(
          this.lastInputValue
        )}&resources[limit_scope]=each&section_id=search-predictive`
      );

      if (!response.ok) {
        var error = new Error(response.status);
        throw error;
      }

      const text = await response.text();
      const resultsMarkup = new DOMParser()
        .parseFromString(text, "text/html")
        .querySelector("#shopify-section-search-predictive").innerHTML;

      // Save bandwidth keeping the cache in all instances synced
      this.allPredictiveSearchInstances.forEach((predictiveSearchInstance) => {
        predictiveSearchInstance.cachedResults[queryKey] = resultsMarkup;
      });
      const div = document.createElement("div");
      div.innerHTML = resultsMarkup;

      const suggestedQueries = div.querySelector("template");
      const currentSuggestedQueries = this.element.querySelector(
        ".predictiveSearch--queries"
      );
      const currentRecentQueris = this.element.querySelector(
        "#predictiveSearch--recentSearches"
      );

      this.searchResultsElement.innerHTML = resultsMarkup;
      this.initCarousel();


      if (new Responsive().matchesBreakpoint("tablet-and-up")) {
        this.element.querySelector('.searchInnerWrapper').style.height = 'auto';
      }


      if (suggestedQueries) {
        if (currentRecentQueris) {
          currentRecentQueris.remove();
        }

        if (currentSuggestedQueries) {
          currentSuggestedQueries.remove();
        }
        const node = suggestedQueries.content.firstElementChild.cloneNode(true);
        this.searchResultsElement.prepend(node);
      }

      this.searchResultsElement.style.opacity = 1;

      if (window.theme.showRecentSearches) {
        this.recentSearches();
      }
    } catch (error) {
      if (error?.code === 20) {
        // Code 20 means the call was aborted
        return;
      }

      throw error;
    }
  }

  resetSearch() {
    this.searchResultsElement.innerHTML = this.initialSearchLayout.innerHTML;
    const currentSuggestedQueries = this.element.querySelector(
      ".predictiveSearch--queries"
    );
    if (currentSuggestedQueries) currentSuggestedQueries.remove();
    this.searchInputElement.value = "";
    this.searchInputElement.removeAttribute("value");




    if (window.theme.showRecentSearches) { this.getRecentSearches(); }

    if (window.theme.showSuggestedSearches) {
      this.getSuggestedSearches();


    }
    this.initCarousel();
    this.searchResultsElement.style.opacity = 1;
    this.clearSearchButton.setAttribute("aria-hidden", "true");
  }

  recentSearches() {
    if (this.lastInputValue.length > 3) {
      var searchTerm = JSON.parse(localStorage.getItem("searchTerms") || "[]");
      if (!searchTerm.includes(this.lastInputValue)) {
        searchTerm.unshift(this.lastInputValue);
      }

      // Then, we save the search info into the local storage, by keeping only the 5 most recent
      try {
        localStorage.setItem(
          "searchTerms",
          JSON.stringify(searchTerm.slice(0, 5))
        );
      } catch (error) { }
    }
  }

  getRecentSearches() {
    let appendString = "";
    const items = JSON.parse(localStorage.getItem("searchTerms") || "[]");
    let elementToAdd = this.element.querySelector(".search--recentResults");
    if (items.length > 0) {
      items.forEach((id) => {
        appendString =
          appendString +
          "<li role='option' tabIndex='0' class='hoverLinks' data-action='search-string' data-value='" +
          id +
          "'>" +
          id +
          "</li>";
      });

      elementToAdd.innerHTML = appendString;
    } else {
      this.querySelector("#predictiveSearch--recentSearches").style.display =
        "none";

    }
  }


  getSuggestedSearches() {
    let appendString = "";
    const arr = this.options.items;

    if (arr.length == 0) {
      return;
    }
    arr.sort(function () {
      return 0.5 - Math.random();
    });
    var filtred = arr.filter(function (a) {
      if (!a.includes("_")) {
        return a;
      }
    });

    var i;
    appendString = "";
    for (i = 0; i < 3; i++) {
      if (filtred[i]) {
        var filteredResult = filtred[i].replace(":", " ");
        filteredResult = filteredResult.replace("-", " ");
        appendString =
          appendString +
          "<li tabindex='0' class='u-p2 searchHoverState' data-action='search-string' data-value='" +
          filteredResult +
          "'>" +
          filteredResult +
          "</li>";
      }

    }
    var appElement = this.searchElement.querySelector(
      ".Search--Suggested__results"
    );
    appElement.innerHTML = appendString;
  }
}
customElements.define("search-bar", SearchBar);

class ContactSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.bindEvents();
    this.toggleButton();
  }

  bindEvents() {
    this.delegateElement.on(
      "change",
      "[data-state='required']",
      this.toggleButton.bind(this)
    );
  }

  toggleButton() {
    this.buttonState = true;

    let allBoxes = this.element.querySelectorAll("[data-state='required']");
    allBoxes.forEach((item, i) => {
      if (item.checked == false) {
        this.buttonState = false;
      }
    });
    if (this.buttonState == true) {
      this.element.querySelector(".contact_form-button").removeAttribute("disabled");
    } else {
      this.element.querySelector(".contact_form-button").setAttribute("disabled", true);
    }
  }
}

customElements.define("contact-section", ContactSection);

class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector(
        'input[name="language_code"], input[name="country_code"]'
      ),
    };
    this.querySelectorAll("a").forEach((item) =>
      item.addEventListener("click", this.onItemClick.bind(this))
    );
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector("form");
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }
}

customElements.define("localization-form", LocalizationForm);

class PickupAvailability extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    if (!this.hasAttribute("available")) return;
    this.fetchAvailability(this.dataset.variantId);
  }

  fetchAvailability(variantId) {
    const variantSectionUrl = `${window.routes.localeRootUrl}/variants/${variantId}/?section_id=helper-pickup`;

    fetch(variantSectionUrl)
      .then((response) => response.text())
      .then((text) => {
        const sectionInnerHTML = new DOMParser()
          .parseFromString(text, "text/html")
          .querySelector(".shopify-section");
        this.renderPreview(sectionInnerHTML);
      })
      .catch((e) => {
        this.renderError();
      });
  }

  renderError() { }

  renderPreview(sectionInnerHTML) {
    this.element.innerHTML = "";

    this.element.appendChild(
      sectionInnerHTML.querySelector(".LocalPickup_--Wrapper")
    );
    if (sectionInnerHTML.querySelector("#LocalPickup")) {
      this.element.appendChild(sectionInnerHTML.querySelector("#LocalPickup"));
      new Drawer(this.element.querySelector("#LocalPickup"));
    }
  }
}

customElements.define("pickup-availability", PickupAvailability);

class CartNote extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.textarea = this.element.querySelector("textarea");
    this.button = this.element.querySelector(".CartNote--Submit");
    this.noteSucess = this.element.querySelector(".cartNote--Success");
    this.bindEvents();
  }
  bindEvents() {
    this.delegateElement.on(
      "click",
      "[data-action='update-note']",
      this.updateNote.bind(this)
    );

    this.delegateElement.on(
      "click",
      "[data-action='edit-note']",
      this.editNote.bind(this)
    );
  }
  editNote() {
    this.textarea.removeAttribute("disabled");
    this.button.innerText = window.cartStrings.enter_note;
    this.button.setAttribute("data-action", "update-note");
    this.textarea.focus();
    this.noteSucess.style.visibility = "hidden";
    this.noteSucess.style.opacity = "0";
  }

  updateNote() {
    var _this = this;
    this.value = this.textarea.value;

    fetch(window.routes.localeRootUrl + "/cart/update.js", {
      body: JSON.stringify({ note: this.value }),
      credentials: "same-origin",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
    }).then(function (response) {
      if (response.ok) {
        if (_this.value == "") {
          return;
        }
        _this.textarea.setAttribute("disabled", "disabled");
        _this.button.innerText = window.cartStrings.note_change;
        _this.button.setAttribute("data-action", "edit-note");
        _this.noteSucess.style.visibility = "visible";
        _this.noteSucess.style.opacity = "1";
      }
    });
  }
}

customElements.define("cart-note", CartNote);

class NewsletterPopup extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.pageOverlayElement = document.querySelector(".pageOverlay");
    this.options = JSON.parse(
      this.element.getAttribute("data-section-settings")
    );

    if (this.options.edit_mode) {
      this.options.delay = 0;
      this.openNewsletter();
    } else {
      this.handleOpenOptions();
    }

    if (
      window.location.href.indexOf("form_type=customer#popupForm") > -1 ||
      window.location.href.indexOf("customer_posted=true#popupForm") > -1 ||
      window.location.href.indexOf("customer_posted=true#nsltForm*") > -1
    ) {
      this.options.delay = 0;
      this.openNewsletter();
    }
  }

  handleOpenOptions() {
    const localKey = localStorage.getItem("popup-seen");

    if (this.options.show_only_once && localKey === "true") return;

    if (localKey !== "true") {
      if (this.options.scroll_amount > 0) {
        document.addEventListener("scroll", this.scrollListener);
      } else {
        this.openNewsletter();
      }
    }
  }

  scrollListener = () => {
    const body = document.body;
    const html = document.documentElement;

    const docHeight = Math.max(
      body.scrollHeight,
      body.offsetHeight,
      html.clientHeight,
      html.scrollHeight,
      html.offsetHeight
    );

    const percScrolled = (window.scrollY / docHeight) * 100;

    if (percScrolled >= this.options.scroll_amount) {
      this.openNewsletter();
    }
  };

  openNewsletter() {
    document.removeEventListener("scroll", this.scrollListener);
    setTimeout(() => {
      this.element.setAttribute("aria-hidden", false);
      this.pageOverlayElement.classList.add("is-visible");
      bodyScrollLock.disableBodyScroll(this.element, bodyScrollLockOptions);

      this.pageOverlayElement.addEventListener("click", this.closeNewsletter);

      localStorage.setItem("popup-seen", true);

      this.delegateElement.on(
        "click",
        '[data-action="close-modal"]',
        this.closeNewsletter
      );


    }, 1000 * this.options.delay);
  }

  closeNewsletter = () => {
    event.preventDefault();
    this.element.setAttribute("aria-hidden", true);
    this.pageOverlayElement.classList.remove("is-visible");
    bodyScrollLock.clearAllBodyScrollLocks();

    if (window.location.href.indexOf("customer_posted=true") !== -1) {
      window.history.replaceState({}, document.title, window.location.href.replace("customer_posted=true#popupForm", ""));
    }
    

    this.pageOverlayElement.removeEventListener("click", this.closeNewsletter);

    document.removeEventListener("scroll", this.scrollListener);
  };
}

customElements.define("newsletter-popup", NewsletterPopup);

class AccountHandler extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);

    this.drawer = new Drawer(this.element.querySelector("#accountDrawer"));
    this.bindEvents();

  }
  bindEvents() {
    this.delegateElement.on(
      "click",
      '[data-action="toggle-tab"]',
      this.toggleTab.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="submit-login"]',
      this.submitLogin.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="submit-register"]',
      this.submitRegistration.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="toggle-recovery"]',
      this.toggleRecovery.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="submit-recovery"]',
      this.accountRecover.bind(this)
    );

    this.delegateElement.on(
      "keypress",
      '[data-action="submit-input-login"]',
      this.accountInputSubmit.bind(this)
    );
    this.delegateElement.on(
      "keypress",
      '[data-action="submit-input-reg"]',
      this.accountInputSubmitReg.bind(this)
    );
    this.delegateElement.on(
      "keypress",
      '[data-action="submit-input-forgot-pass"]',
      this.accountInputSubmitForgot.bind(this)
    );
  }

  accountInputSubmit(event) {
    if (event.key === "Enter") this.submitLogin(event);
  }
  accountInputSubmitReg(event) {
    if (event.key === "Enter") this.submitRegistration(event);
  }
  accountInputSubmitForgot(event) {
    if (event.key === "Enter") {
      event.preventDefault();
      this.accountRecover(event);
    }
  }


  toggleRecovery() {
    event.preventDefault();
    const id = event.target.dataset.id;

    if (id == "recoverFlex") {
      this.element
        .querySelector("#recoverFlex")
        .setAttribute("aria-visible", "true");
      this.element
        .querySelector("#loginFlex")
        .setAttribute("aria-visible", "false");
    } else {
      this.element
        .querySelector("#recoverFlex")
        .setAttribute("aria-visible", "false");
      this.element
        .querySelector("#loginFlex")
        .setAttribute("aria-visible", "true");
    }
  }

  accountRecover(event) {
    event.preventDefault();
    const _this = this;
    const registrationEndpoint = "/account/recover";

    // Create the request body with the registration data
    const requestBody = {
      email: this.element.querySelector("#RecoverEmail").value,
    };


    event.target.closest('form').querySelector(".itemLoader")?.classList.add("is-visible");

    // Send the AJAX request
    (async function () {
      try {
        const response = await fetch(registrationEndpoint, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestBody),
        });

        const responseText = await response.text();
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = responseText;

        if (responseText.indexOf("RecoverEmail-email-error") !== -1) {
          _this.element.querySelector(

            "#recoverFlex .accountDrawer--SuccessSpace"
          ).innerHTML = "";
          _this.element.querySelector(
            "#recoverFlex .accountDrawer--ErrorSpace"
          ).innerHTML =
            '<span class="AlertErrorInner pt-m u-p4">' +
            tempDiv.querySelector("#RecoverEmail-email-error").innerHTML +
            "</span>";
        } else if (responseText.indexOf("recoverSuccess") !== -1) {
          _this.element.querySelector(
            "#recoverFlex .accountDrawer--ErrorSpace"
          ).innerHTML = "";
          _this.element.querySelector(
            "#recoverFlex .accountDrawer--SuccessSpace"
          ).innerHTML =
            '<span class="AlertErrorInner pt-m u-p4">' +
            tempDiv.querySelector("#recoverSuccess").innerHTML +
            "</span>";
        } else if (
          responseText.indexOf("shopify-challenge__container") !== -1
        ) {
          location.href = "/challenge";
        }
        event.target.closest('form').querySelector(".itemLoader")?.classList.remove("is-visible");

      } catch (error) {
        console.log(
          "An error occurred during the registration request:",
          error
        );
      }
    })();
  }

  submitRegistration(event) {
    event.preventDefault();
    const _this = this;
    const registrationEndpoint = "/account";

    // Create the request body with the registration data
    const requestBody = {
      customer: {
        first_name: this.element.querySelector(
          "#register #RegisterForm-FirstName"
        ).value,
        last_name: this.element.querySelector(
          "#register #RegisterForm-LastName"
        ).value,
        email: this.element.querySelector("#register #RegisterForm-email")
          .value,
        password: this.element.querySelector("#register #RegisterForm-password")
          .value,
      },
    };

    event.target.closest('form').querySelector(".itemLoader")?.classList.add("is-visible");

    // Send the AJAX request
    (async function () {
      try {
        const response = await fetch(registrationEndpoint, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestBody),
        });

        const responseText = await response.text();

        if (responseText.indexOf("registerErrors") !== -1) {
          console.log("Error occurred during registration");
          const tempDiv = document.createElement("div");
          tempDiv.innerHTML = responseText;


          const emailError = tempDiv.querySelector("#RegisterForm-email-error");
          const passwordError = tempDiv.querySelector(
            "#RegisterForm-password-error"
          );

          if (emailError)
            _this.element.querySelector(
              "#RegisterForm-email-error"
            ).innerHTML = `<div class="AlertErrorInner u-p4 pt-m">${tempDiv.querySelector("#RegisterForm-email-error").innerHTML
            }</div>`;
          if (passwordError)
            _this.element.querySelector(
              "#RegisterForm-password-error"
            ).innerHTML = `<div class="AlertErrorInner u-p4 pt-m">${tempDiv.querySelector("#RegisterForm-password-error").innerHTML
            }</div>`;
        } else if (
          responseText.indexOf("shopify-challenge__container") !== -1
        ) {
          location.href = "/challenge";
        } else {
          location.href = window.routes.account_url;
        }
        event.target.closest('form').querySelector(".itemLoader")?.classList.remove("is-visible");

      } catch (error) {
        console.log(
          "An error occurred during the registration request:",
          error
        );
      }
    })();
  }

  submitLogin(event) {
    event.preventDefault();
    const _this = this;
    const loginEndpoint = "/account/login";

    // Create the request body with the login credentials
    const requestBody = {
      customer: {
        email: this.element.querySelector("#customer_login #CustomerEmail")
          .value,
        password: this.element.querySelector(
          "#customer_login #CustomerPassword"
        ).value,
      },
    };


    event.target.closest('form').querySelector(".itemLoader")?.classList.add("is-visible");

    // Send the AJAX request
    (async function () {
      try {
        const response = await fetch(loginEndpoint, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestBody),
        });

        const responseText = await response.text();

        if (responseText.indexOf("loginError") !== -1) {
          console.log("Incorrect email or password");
          const tempDiv = document.createElement("div");

          tempDiv.innerHTML = responseText;

          _this.element.querySelector(
            "#login .accountDrawer--ErrorSpace"


          ).innerHTML = `<div class="AlertErrorInner u-p4 pb-m">${tempDiv.querySelector(".AlertError").innerHTML

          }</div>`;

          event.target.closest('form').querySelector(".itemLoader")?.classList.remove("is-visible");
        } else if (
          responseText.indexOf("shopify-challenge__container") !== -1
        ) {
          location.href = "/challenge";
        } else {

          location.href = window.routes.account_url;
        }
      } catch (error) {
        console.log("An error occurred during the login request:", error);
      }
    })();
  }

  toggleTab(event) {
    const id = event.target.dataset.id;
    const allTabs = this.element.querySelectorAll(
      '.accountDrawer--Tab[aria-expanded="true"]'
    );
    const allContent = this.element.querySelectorAll(".accountContent");

    allTabs.forEach((tab) => {
      tab.setAttribute("aria-expanded", "false");
    });


    const dataId = event.target.dataset.id;
    this.element
      .querySelectorAll(`.accountDrawer--Tab[data-id="${dataId}"]`)
      .forEach((el) => el.setAttribute("aria-expanded", "true"));


    allContent.forEach((content) => {
      content.setAttribute("aria-visible", "false");
    });

    const content = this.element.querySelector(`#${id}`);
    if (content) {
      content.setAttribute("aria-visible", "true");
    }
  }
}

customElements.define("account-handler", AccountHandler);

class LocalizationSelectors extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    let responsive = new Responsive();
    let breakpoint = responsive.getCurrentBreakpoint();
    var selectBoxes = this.element.querySelectorAll(".RevolutionSelectbox");
    var dropdownSelectboxes = this.element.querySelectorAll(".Dropdown");
    var location = this.element.getAttribute("data-settings");

    if (location == "sidebarMenu") {
      var additionalOverlay = true;
    } else {
      var additionalOverlay = false;
    }
    if (breakpoint != "phone" && breakpoint != "tablet") {
      if (selectBoxes.length > 0) {
        selectBoxes.forEach((item, i) => {
          new RevolutionSelectbox(item);
        });
      }
    } else {
      if (dropdownSelectboxes.length > 0) {
        dropdownSelectboxes.forEach((item, i) => {
          new RevolutionSelectbox(item);
        });
      }
    }
  }
}
customElements.define("localization-selectors", LocalizationSelectors);


class UniqueSellingPoints extends HTMLElement {
  constructor() {
    super();
    this.element = this;


    // Mobile main swiper
    this.swiper = this.element.querySelector(".usp--swiper");
    this.swiper = new RevolutionSwiper(this.swiper);


    this.btnPrev = this.element.querySelector(".usp--btnPrev");
    this.btnNext = this.element.querySelector(".usp--btnNext");

    this.btnPrev.addEventListener("click", () =>
      this.swiper.swiperElement.slidePrev(200)
    );
    this.btnNext.addEventListener("click", () =>
      this.swiper.swiperElement.slideNext(200)
    );
  }
}
customElements.define("unique-selling-points", UniqueSellingPoints);

class faqSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.initObserver();

    this.bindEvents();
  }

  bindEvents() {
    this.delegateElement.on(
      "click",
      '[data-action="handle-click"]',
      this.handleClick.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="clear-search"]',
      this.clearSearch.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="clear-search-d"]',
      this.clearSearchDesktop.bind(this)
    );
    this.delegateElement.on(
      "keyup",
      '[data-action="search-string"]',
      this.handleSearch.bind(this)
    );


  }

  insertInInput(event, target) {
    this.inputEl = this.element.querySelector(".faq--search.mobile");
    const liText = event.target.textContent;
    this.inputEl.value = liText;
  }
  handleSearch(event) {
    //Mobile
    const clearBtn = this.element.querySelector(
      ".clearSearch.supportFaq--mobileClearBtn"
    );
    // Set the input value and display/hide the clear button
    let inputValue = this.element.querySelector(".faq--search.mobile").value;
    if (inputValue == "") {
      clearBtn.style.display = "none";
    } else {
      clearBtn.style.display = "flex";
      const noneTerms = this.querySelectorAll(".noTerms");
      noneTerms.forEach((el) => (el.textContent = `"${inputValue}"`));
    }
    this.quickSearch(inputValue);
  }


  quickSearch(inputSearch) {
    inputSearch = inputSearch.toLowerCase();

    const divContainers = this.querySelectorAll(".Faq-Section");

    divContainers.forEach((container) => {
      const containerText = container.textContent.toLowerCase();

      if (containerText.includes(inputSearch)) {
        container.style.display = "block";
        container.classList.add("supportFaq--showed");
      } else {
        container.style.display = "none";
        container.classList.remove("supportFaq--showed");
      }
    });

    this.handleNoResults(divContainers);
  }

  handleNoResults(containers) {
    let sign = false;
    this.noResEl = this.querySelectorAll(".faq--noResultsText");

    containers.forEach((container) => {
      if (container.classList.contains("supportFaq--showed")) {
        sign = true;
      }
    });

    if (sign === false) {
      this.noResEl.forEach((item) => {
        item.style.display = "flex";
        item.classList.add("noResult--showed");
      });
    } else {
      this.noResEl.forEach((item) => {
        item.style.display = "none";
      });
    }
  }

  clearSearch() {
    this.clearBtn = this.element.querySelector(
      ".clearSearch.supportFaq--mobileClearBtn"
    );
    this.inputValue = this.element.querySelector(".faq--search.mobile");
    this.inputValue.value = "";
    this.clearBtn.style.display = "none";
    this.noReslutEl = this.element.querySelector(".faq--noResultsText");
    this.noReslutEl.style.display = "none";

    this.quickSearch(this.inputValue.value);
  }

  clearSearchDesktop() {
    this.clearBtn_d = this.element.querySelector(
      ".clearSearch.supportFaq--desktopClearBtn"
    );
    this.inputValue_d = this.element.querySelector(".faq--search.desktop");
    this.inputValue_d.value = "";
    this.clearBtn_d.style.display = "none";
    this.quickSearch(this.inputValue_d.value);
  }

  handleClick() {
    const allLinks = this.element.querySelectorAll(".FaqLinkList__Item");
    allLinks.forEach((item) => {
      item.classList.remove("CurrentLinkPage");
    });
    event.target.classList.add("CurrentLinkPage");
  }

  removeAllLinks() {
    const linkedOne = this.element.querySelectorAll(".CurrentLinkPage");
    if (linkedOne) {
      linkedOne.forEach((item) => {
        item.classList.remove("CurrentLinkPage");
      });
    }
  }

  initObserver() {
    window.addEventListener("scroll", this.handleScroll.bind(this));
  }

  handleScroll() {
    const faqSubheaders = this.element.querySelectorAll(".FAQSubheader");
    const faqMenuTabsWrapper = this.element.querySelector(
      ".faq--menuTabsWrapper"
    );
    if (new Responsive().matchesBreakpoint("pocket")) {
      if (faqMenuTabsWrapper) {
        const distanceFromTop = faqMenuTabsWrapper.getBoundingClientRect().top;
        const threshold = 52;

        if (distanceFromTop <= threshold && distanceFromTop > 0) {
          faqMenuTabsWrapper.style.boxShadow =
            "0px 4px 12px 0px rgba(20, 20, 20, 0.10)";
        } else {
          faqMenuTabsWrapper.style.boxShadow = "none";
        }
      }
    }
    // Adjust the threshold as needed (e.g., 100px)
    const threshold = 100;

    faqSubheaders.forEach((faqSubheader) => {
      const distanceFromTop = Math.max(
        0,
        faqSubheader.getBoundingClientRect().top
      );

      if (distanceFromTop <= threshold && distanceFromTop > 0) {
        this.removeAllLinks();
        const faqSection = faqSubheader.closest(".Faq-Section").id;
        const anchorElement = this.element.querySelectorAll(
          `a[href="#${faqSection}"]`
        );

        if (anchorElement) {
          anchorElement.forEach((item) => {
            item.classList.add("CurrentLinkPage");
          });
          if (new Responsive().matchesBreakpoint("pocket")) {
            anchorElement.forEach((item) => {
              if (!item.classList.contains("swiper-slide-active")) {
                this.carousel.swiperElement.slideTo(
                  parseInt(item.dataset.index)
                );
              }
            });
          }
        }
      }
    });
  }
}

customElements.define("faq-section", faqSection);


class SliderAnnouncementBar extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.options = JSON.parse(this.getAttribute("data-settings"));


    this.announcementBar = document.querySelector(".announcementBar");
    this.updateVisibleHeight();
    document.documentElement.style.setProperty(
      "--announcement-height-fixed",
      this.element.clientHeight + "px"
    );

    if (this.options.totalBlocks < 6) {
      this.animateBig = false;
    } else {
      this.animateBig = true;
    }

    if (this.options.totalBlocks > 0 && this.options.enableAnimation) {
      this.announcementBar1 = this.element.querySelector(
        "#announcementBar--SwiperWrapperOne"
      );
      this.announcementBar2 = this.element.querySelector(
        "#announcementBar--SwiperWrapperTwo"
      );
      this.slides = this.element.querySelectorAll(".announcementBar--Slide");
      this.fadeToggle = false;
      this.firstAnimation = true;

      window.onload = () => setTimeout(() => this.updateVisibleHeight(), 500);
      this.handleSmallAnimation();
    }
    this.bindEvents();
  }

  bindEvents() {


    window.addEventListener("scroll", this.updateVisibleHeight.bind(this));
    window.addEventListener("resize", this.updateVisibleHeight.bind(this));
  }

  updateVisibleHeight() {
    const rect = this.announcementBar.getBoundingClientRect();
    const windowHeight = window.innerHeight;

    // Calculate the visible height
    let visibleHeight =
      Math.min(rect.bottom, windowHeight) - Math.max(rect.top, 0);

    // Ensure the visibleHeight is never negative
    visibleHeight = Math.max(visibleHeight, 0);

    // Update the height of .announcementBar with the visible height
    document.documentElement.style.setProperty(
      "--announcement-dynamic-height",
      `${visibleHeight}px`
    );
  }

  toggleFade() {
    this.announcementBar2.style.display = "flex";

    if (this.fadeToggle) {
      this.announcementBar1.classList.remove("fade-in");
      this.announcementBar2.classList.add("fade-in");
    } else {
      this.announcementBar1.classList.add("fade-in");
      this.announcementBar2.classList.remove("fade-in");
    }

    this.fadeToggle = !this.fadeToggle;
  }

  fadeBig() {
    // Initially fade in the first bar
    this.announcementBar1.classList.add("fade-in");

    this.slides.forEach((slide) => (slide.style.visibility = "visible"));

    if (this.animateBig)
      this.barsTimeout = setInterval(
        () => this.toggleFade(),
        this.options.interval
      );
  }

  fadeSmall() {
    const mySlides = this.slides;
    const numSlides = mySlides.length;
    let currentSlideIndex = 0;

    const animate = () => {
      if (currentSlideIndex > 0) {
        mySlides[currentSlideIndex - 1].classList.remove("fade-in");
      }

      mySlides[currentSlideIndex].classList.add("fade-in");

      this.slidesTimeout = setTimeout(() => {
        mySlides[currentSlideIndex].classList.remove("fade-in");
        currentSlideIndex = (currentSlideIndex + 1) % numSlides;
        animate();
      }, this.options.interval);
    };

    animate();
  }

  stopFadeBig() {
    this.announcementBar1.style.display = "none";
    this.announcementBar2.style.display = "none";

    this.announcementBar1.classList.remove("fade-in");
    this.announcementBar2.classList.remove("fade-in");

    setTimeout(() => {
      this.announcementBar1.style.display = "flex";
      this.announcementBar2.style.display = "flex";
    }, 100);

    clearTimeout(this.barsTimeout);
  }

  stopFadeSmall() {
    this.slides.forEach((slide) => {
      if (slide.classList.contains("fade-in")) {
        slide.classList.remove("fade-in");
      }
    });
    clearTimeout(this.slidesTimeout);
  }

  handleBigAnimation() {
    if (!this.firstAnimation) {
      this.stopFadeSmall();

      this.announcementBar1.style.display = "none";
      if (this.animateBig) this.announcementBar2.style.display = "none";

      setTimeout(() => {
        this.announcementBar1.style.display = "flex";
      }, 75);

      setTimeout(() => {
        this.fadeBig();
      }, 150);
    } else {
      if (this.animateBig) this.announcementBar2.style.display = "none";
      this.fadeBig();
    }
    if (this.firstAnimation) this.firstAnimation = !this.firstAnimation;
  }

  handleSmallAnimation() {
    if (!this.firstAnimation && this.animateBig) this.stopFadeBig();

    this.slides.forEach((slide, index) => {
      if (index !== 0) slide.style.display = "none";
    });

    setTimeout(() => {
      this.fadeSmall();

      this.slides.forEach((slide, index) => {
        if (index !== 0) slide.style.display = "flex";
      });

      if (this.firstAnimation) this.firstAnimation = !this.firstAnimation;
    }, 150);
  }
}
customElements.define("slider-announcement-bar", SliderAnnouncementBar);
class CustomOne extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElem = new Delegate(this.element);
    this.moveContainer = this.element.querySelector(
      ".custom-one__move-container"
    );
    this.moveCircle = this.element.querySelector(".custom-one__move-circle");
    this.moveCircleMobile = this.element.querySelector(
      ".custom-one__move-circle--mobile"
    );
    this.containerRect = this.element.getBoundingClientRect();

    this.parseText();
    this.settings();
    this.bindEvents();
    this.handleScroll();
  }

  bindEvents() {
    this.showImageOrVideoBinder = this.showImageOrVideo.bind(this);
    this.moveImageOrVideoBinder = this.moveImageOrVideo.bind(this);
    this.hideImageOrVideoBinder = this.hideImageOrVideo.bind(this);

    const mediaQuery = window.matchMedia("(min-width: 1025px)");
    mediaQuery.addEventListener(
      "change",
      this.handleBreakpointChange.bind(this)
    );
    this.handleBreakpointChange(mediaQuery);

    window.addEventListener("scroll", this.handleScroll.bind(this));
  }

  bindObserver() {
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.showImageOrVideo();
          } else {
            this.hideImageOrVideo();
          }
        });
      },
      { threshold: 0.25 }
    );

    this.observer.observe(this.element);
  }

  handleBreakpointChange(mql) {
    if (this.moveContainer) {
      if (mql.matches) {
        this.delegateElem.on(
          "mouseenter",
          "[data-action='pointer-move']",
          this.showImageOrVideoBinder
        );
        this.delegateElem.on(
          "mousemove",
          "[data-action='pointer-move']",
          this.moveImageOrVideoBinder
        );
        this.delegateElem.on(
          "mouseleave",
          "[data-action='pointer-move']",
          this.hideImageOrVideoBinder
        );
        if (this.observer) {
          this.observer.unobserve(this.element);
        }
      } else {
        this.moveContainer.style.transform = "";
        this.delegateElem.off(
          "mouseenter",
          "[data-action='pointer-move']",
          this.showImageOrVideoBinder
        );
        this.delegateElem.off(
          "mousemove",
          "[data-action='pointer-move']",
          this.moveImageOrVideoBinder
        );
        this.delegateElem.off(
          "mouseleave",
          "[data-action='pointer-move']",
          this.hideImageOrVideoBinder
        );
        this.bindObserver();
      }
    }
  }

  settings() {
    this.keyframesFill = [{ color: "var(--primary_text)" }];

    this.keyframesReset = [{ color: "transparent" }];

    this.options = {
      duration: 350,
      easing: "linear",
      fill: "forwards",
    };

    this.textBox = this.element.querySelector(".custom-one__text");
    this.letters = this.textBox.querySelectorAll(".custom-one__letter");

    this.scrollDistancePerLetter =
      (window.innerHeight - 72) / this.totalLetters;
  }

  handleScroll() {
    this.containerRect = this.element.getBoundingClientRect();
    const scrollPosition =
      window.innerHeight - 72 - this.textBox.getBoundingClientRect().top;

    this.letters.forEach((letter, index) => {
      const letterScrollPosition = index * this.scrollDistancePerLetter;
      if (letterScrollPosition <= scrollPosition) {
        letter.animate(this.keyframesFill, this.options);
      } else {
        letter.animate(this.keyframesReset, this.options);
      }
    });
  }

  showImageOrVideo() {
    this.moveContainer.classList.add("show");
    this.moveCircle.classList.add("show");
    this.moveCircleMobile.classList.add("show");
  }

  moveImageOrVideo(e) {
    const mouseX = e.clientX - this.containerRect.left;
    const mouseY = e.clientY - this.containerRect.top;

    requestAnimationFrame(() => {
      this.moveContainer.style.transform = `translate(${mouseX}px, ${mouseY}px)`;
      this.moveCircle.style.transform = `translate(${mouseX}px, ${mouseY}px)`;
    });

    const elementsUnderCursor = document.elementsFromPoint(
      e.clientX,
      e.clientY
    );
    const container = elementsUnderCursor.find((element) =>
      element.classList.contains("custom-one__wrapper")
    );
    if (!container) {
      this.hideImageOrVideo();
    } else {
      this.showImageOrVideo();
    }
  }

  hideImageOrVideo() {
    this.moveContainer.classList.remove("show");
    this.moveCircle.classList.remove("show");
    this.moveCircleMobile.classList.remove("show");
  }

  parseText() {
    this.totalLetters = 0;
    this.element.querySelectorAll(".custom-one__text p").forEach((elem) => {
      var words = elem.textContent.split(" ");

      elem.innerHTML = words
        .map((word) => {
          var letters = word.split("");
          this.totalLetters += letters.length;
          letters = letters
            .map((letter) => {
              return (
                '<span class="custom-one__letter u-h1">' + letter + "</span>"
              );
            })
            .join("");
          return '<span class="custom-one__word">' + letters + " </span>";
        })
        .join(" ");
    });
  }
}
customElements.define("custom-one", CustomOne);

sessionStorage.setItem("firstLoadFav", true);
class FavoritesDrawer extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.sidebarDrawer = new Drawer(this.element);
    this.delegateBody = new Delegate(document.body);
    this.options = JSON.parse(this.element.getAttribute("data-settings"));
    this.loader = this.element.querySelector(".spinningLoader");
    this.cartCount = document.querySelector(".FavoritesCount");
    this.favEmpty = document.querySelectorAll(".TopBar--FavEmpty");
    this.favFull = document.querySelectorAll(".TopBar--FavFull");
    if (sessionStorage.getItem("firstLoadFav") === "true") {
      sessionStorage.setItem("firstLoadFav", false);
      this.loader.classList.add("is-visible");
      this.rerenderFavorites();
    }


    this.toggleFavorites();
    this.bindEvents();
  }
  unbindEvents() {
    document.removeEventListener(
      "favorite-product:open",
      this.onFavoritesOpenListener
    );

    document.removeEventListener("click", this._addToFavoritesL);
  }
  bindEvents() {
    if (!document.body.classList.contains("listener")) {
      this.onFavoritesOpenListener = this.onFavoritesOpen.bind(this);
      this._addToFavoritesL = this.addToFavorites.bind(this);

      this.delegateBody.on(
        "click",
        '[data-action="toggle-favorites"]',
        this._addToFavoritesL
      );
      document.body.classList.add("listener");
      document.addEventListener(
        "favorite-product:open",
        this.onFavoritesOpenListener
      );
      document.addEventListener(
        "favorites:toggle",
        this.toggleFavorites.bind(this)
      );
    }

  }

  onFavoritesOpen() {
    this.sidebarDrawer.isOpen = true;
  }


  getSearchQueryStrings() {
    var items = JSON.parse(localStorage.getItem("productFavorites") || "[]");
    // Filter out null values
    items = items.filter((id) => id !== null);
    const bucketSize = 10.0;
    const idBuckets = [];
    items.forEach((id, index) => {
      const key = Math.floor(index / bucketSize);
      if (!idBuckets[key]) {
        idBuckets[key] = [];
      }
      idBuckets[key].push(id);
    });
    return idBuckets.reduce((acc, vall) => {
      const string = vall
        .filter((id) => id !== null) // Filter out null values
        .map(function (id) {
          return "id:" + id;
        })
        .join(" OR ");

      if (string) {
        acc.push(string); // Add the string to the result array if it's not empty
      }
      return acc;
    }, []);
  }

  hideLoader(noDelay) {
    let delay;
    noDelay ? (delay = 0) : (delay = 500);
    setTimeout(() => {
      this.loader.classList.remove("is-visible");
    }, delay);
  }

  rerenderFavorites(openfavorites) {
    var _this32 = this;
    var queryStrings = this.getSearchQueryStrings();
    const promises = [];
    if (queryStrings.length == 0)
      this.favFull.forEach((icon) => (icon.style.opacity = 0));
    else this.favFull.forEach((icon) => (icon.style.opacity = 1));

    if (queryStrings.length == 0 && !openfavorites) {
      fetch("/?section_id=main-favorites_drawer").then(function (content) {
        content.text().then(function (html) {
          _this32.replaceContentFav(html, 0);
          _this32.loadRecommendations();
        });
      });
    }
    queryStrings.forEach((string) => {
      promises.push(
        fetch("/search?view=favorites&type=product&q=" + string, {
          credentials: "same-origin",
          method: "GET",
        })
      );
    });
    promises.reduce(async (previousPromise, nextPromise, index) => {
      await previousPromise; // Wait for the previous promise to be resolved
      const response = await nextPromise; // Wait for the current promise to be resolved
      const content = await response.text(); // Get the text from the response

      const container = this.element; // Assuming this.element is defined in your context
      if (!container || !container.length) { // Check if the container is not defined or empty
        this.replaceContentFav(content, index); // Execute replacement or modification function
      }
    }, Promise.resolve()); // Initial value for the accumulator

    return Promise.resolve();
  }

  replaceContentFav(html, index) {
    var tempElement = document.createElement("div");
    tempElement.innerHTML = html;
    var cartNodeParent = this.element.querySelector(
      ".favorites-drawer_wrapper"
    );

    if (index == 0) {
      cartNodeParent.replaceChild(
        tempElement.querySelector(".favorites-drawer_content"),
        this.element.querySelector(".favorites-drawer_content")
      );
    } else {
      const favoritesGrid = cartNodeParent.querySelector('.favorites-drawer_product-grid');
      const newFavorites = tempElement.querySelectorAll('.favorites-drawer_product-grid product-card');
      newFavorites.forEach(productCard => favoritesGrid.appendChild(productCard));
    }

    if (!tempElement.querySelector('.favorites-drawer_empty')) {
      this.toggleFavorites();
      this.hideLoader();
    }

    return true;
  }

  toggleFavorites() {
    var items = JSON.parse(localStorage.getItem("productFavorites") || "[]");
    var favorites = [
      ...document.querySelectorAll(".product-card__favorites-icon"),
    ];

    if (document.body.querySelector(".empty-favorite")) {
      if (items.length > 0) {
        document.body.querySelector(".empty-favorite").style.display = "none";
        document.body.querySelector(".solid-favorite").style.display = "flex";
      } else {
        document.body.querySelector(".empty-favorite").style.display = "flex";
        document.body.querySelector(".solid-favorite").style.display = "none";
      }
    }
    favorites.forEach(function (item) {
      var state = item.getAttribute("state");
      var myID = item.getAttribute("data-id");
      if (state == "not-active" && items.includes(myID)) {
        item.querySelector(".solid-favorite").style.display = "flex";
        item.querySelector(".empty-favorite").style.display = "none";
        item.setAttribute("state", "active");
      } else if (!items.includes(myID)) {
        item.querySelector(".solid-favorite").style.display = "none";
        item.querySelector(".empty-favorite").style.display = "flex";
        item.setAttribute("state", "not-active");
      }
    });
  }

  removeFromFavorites(productId) {
    var items = JSON.parse(localStorage.getItem("productFavorites") || "[]");
    items = items.filter((c) => c != productId);
    if (items.length == 0) this.loader.classList.add("is-visible");
    try {
      localStorage.setItem(
        "productFavorites",
        JSON.stringify(items.slice(0, 50))
      );
    } catch (error) {
      console.log(error);
    }

    this.toggleFavorites();
    this.rerenderFavorites();


  }

  loadRecommendations() {
    const _this = this;

    if (this.options["productId"] == "") {
      var url = "?section_id=helper-recommendations";
    } else {
      var url =
        window.routes.localeRootUrl +
        "/recommendations/products?section_id=helper-recommendations&product_id=" +
        this.options["productId"] +
        "&limit=10";
    }


    return fetch(url).then(function (response) {
      return response.text().then(function (content) {
        const container = document.createElement("div");
        if (container) container.innerHTML = content;

        if (container) {
          var z = container.querySelector(".Upsell__Container").innerHTML;
          var x = _this.element.querySelector(".favorites-drawer_recommendations-wrapper .swiper-wrapper");
          if (x != null) {
            x.innerHTML = z;
          }
        }

        const swiper = new Swiper(".favorites-drawer_recommendations-wrapper .swiper", {
          // Default parameters
          slidesPerView: 2,
          spaceBetween: 16,
          slidesOffsetAfter: 0,
          slidesOffsetBefore: 0,
          mousewheel: {
            forceToAxis: true,
          },
          navigation: {
            nextEl: ".favorites-drawer_recommendations-button--nextEl",
            prevEl: ".favorites-drawer_recommendations-button--prevEl",
          },
          breakpoints: {
            1025: {
              slidesPerView: 3,
            },
          },
        });



        _this.toggleFavorites();
        _this.hideLoader();
        if (window.theme.enableAnimations) {
          new RevolutionAnimation(_this.element);
        }
      });
    });
  }

  addToFavorites(event) {
    event.preventDefault();

    var items = JSON.parse(localStorage.getItem("productFavorites") || "[]");
    if (items.length == 0) this.loader.classList.add("is-visible");
    var productId = event.target.parentElement.getAttribute("data-id");
    if (!productId) productId = event.target.getAttribute("data-id");

    // We check if the current product already exists, and if it does not, we add it at the start
    if (!items.includes(productId) && productId != "") {
      items.unshift(productId);
    } else {
      this.removeFromFavorites(productId, false);
      //   this._favoritesNumber();
      return;
    }
    // Then, we save the current product into the local storage, by keeping only the 50 most recent
    try {
      localStorage.setItem(
        "productFavorites",
        JSON.stringify(items.slice(0, 50))
      );
      //    this._favoritesNumber();
      this.toggleFavorites();
      this.rerenderFavorites();
  
    } catch (error) {
      // Do nothing, this may happen in Safari in incognito mode
    }

  }
}
customElements.define("favorites-drawer", FavoritesDrawer);


class CollectionShowcase extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElem = new Delegate(this.element);
    this.moveContainer = this.element.querySelector('.collection-showcase__move-container');
    this.moveCircle = this.element.querySelector('.collection-showcase__move-circle');
    this.containerRect = this.element.getBoundingClientRect();

    this.handleBreakpointChange();
  }

  handleBreakpointChange() {
    this.moveImageContainerBinder = this.moveImageContainer.bind(this);

    const mediaQuery = window.matchMedia("(min-width: 768px)");
    mediaQuery.addEventListener("change", this.bindEvents.bind(this));
    this.bindEvents(mediaQuery);
  }

  bindEvents(mql) {
    if (mql.matches) {
      this.delegateElem.on("mousemove", "[data-action='pointer-move']", this.moveImageContainerBinder);
      this.swiperInstances = [];
      this.desktopSwipers = this.element.querySelectorAll('.collection-showcase__desktop-swiper');
      this.desktopSwipers.forEach(swiper => this.swiperInstances.push(new RevolutionSwiper(swiper)));

      if (this.mobileSwiper) {
        this.mobileSwiper.destroyInstance();
      }
    } else {
      this.delegateElem.off("mousemove", "[data-action='pointer-move']", this.moveImageContainerBinder);
      if (this.swiperInstances && this.swiperInstances.length > 0) {
        this.swiperInstances.forEach(swiper => swiper.destroyInstance());
      }

      this.mobileSwiperElement = this.element.querySelector('.collection-showcase__mobile-swiper');
      this.mobileSwiper = new RevolutionSwiper(this.mobileSwiperElement);
      this.mobileSwiperElement.swiper.on("slideChangeTransitionEnd", this.updateImageToShowMobile.bind(this));
      this.updateImageToShowMobile();
    }
  }

  updateImageToShowMobile() {
    const activeSlideId = this.mobileSwiperElement.swiper.slides[this.mobileSwiperElement.swiper.activeIndex].dataset.id;
    this.element.querySelector('.collection-showcase__image-wrapper--mobile.show')?.classList.remove('show');
    this.element.querySelector(`.collection-showcase__image-wrapper--mobile[data-id="${activeSlideId}"]`)?.classList.add('show');
  }

  updateImageToShow(elementsUnderCursor) {
    this.containerRect = this.element.getBoundingClientRect();

    let newImageToShow;
    newImageToShow = elementsUnderCursor.find((element) => element.classList.contains('collection-showcase__desktop-swiper'));

    if (!newImageToShow) {
      if (this.imageToShow) this.imageToShow.classList.remove('show');
      return null;
    }

    const newImageToShowID = newImageToShow.dataset.id;
    newImageToShow = this.moveContainer.querySelector(`.collection-showcase__image-wrapper--desktop[data-id="${newImageToShowID}"]`);
    this.moveCircle.href = newImageToShow.href;

    if (this.imageToShow && newImageToShow !== this.imageToShow) {
      this.imageToShow.classList.remove('show');
      this.querySelector('.collection-showcase__collection-placeholder.hide')?.classList.remove('hide');
    }

    this.element.querySelector(`.collection-showcase__collection-placeholder[data-id="${newImageToShowID}"]`)?.classList.add('hide');

    return newImageToShow;
  }

  showImageContainer() {
    this.moveContainer.classList.add('show');
    this.moveCircle.classList.add('show');
  }

  hideImageContainer() {
    this.moveContainer.classList.remove('show');
    this.moveCircle.classList.remove('show');

    this.querySelectorAll('.collection-showcase__collection-placeholder').forEach(el => el.classList.remove('hide'));
  }

  moveImageContainer(e) {
    const elementsUnderCursor = document.elementsFromPoint(e.clientX, e.clientY);
    const swiper = elementsUnderCursor.find((element) => element.classList.contains('collection-showcase__desktop-swiper'));

    if (swiper) {
      this.showImageContainer();

      const mouseX = e.clientX - this.containerRect.left;
      const mouseY = e.clientY - this.containerRect.top;

      const elementsUnderCursor = document.elementsFromPoint(e.clientX, e.clientY);
      const newImageToShow = this.updateImageToShow(elementsUnderCursor);
      if (!newImageToShow) return;

      this.imageToShow = newImageToShow;
      if (this.imageToShow) this.imageToShow.classList.add('show');
      requestAnimationFrame(() => {
        this.moveContainer.style.transform = `translate(${mouseX}px, ${mouseY}px)`;
        this.moveCircle.style.transform = `translate(${mouseX}px, ${mouseY}px)`;
      });
    } else {
      this.hideImageContainer();
    }
  }
}
customElements.define("collection-showcase", CollectionShowcase);



sessionStorage.setItem("firstLoadRecomm", true);
class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this);


    if (sessionStorage.getItem("firstLoadRecomm") === "true") {
      sessionStorage.setItem("firstLoadRecomm", false);
      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("product-recommendations");
          if (recommendations && recommendations.innerHTML.trim().length) {
            const carouselElementNew = recommendations.querySelector(".swiper");
            const carouselElementOld = this.querySelector(".swiper");

            carouselElementOld.parentNode.replaceChild(
              carouselElementNew,
              carouselElementOld
            );

            carouselElementNew.classList.add("recomm-loaded");

            new RevolutionSwiper(carouselElementNew);
            new RevolutionAnimation(carouselElementNew, true);
          }

        })
        .catch((e) => {
          console.error(e);
        });

    }
  }
}

customElements.define("product-recommendations", ProductRecommendations);

class ProductCard extends HTMLElement {

  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);

    this.atcButton = this.element.querySelector(".product-card__add-to-cart");
    this.selectedValue = this.element.querySelector(".product-card__color-selector input:checked")?.value;
    this.sizeSelector = this.element.querySelector(".product-card__size-selector");
    this.sizeOptionPresent = this.element.querySelector(".product-card__input-selectbox--size");
    this.productForm = this.element.querySelector(`.product-form`);

    this.selectorInit = false;


    this.bindEvents();
  }

  bindEvents() {

    if (this.selectedValue) {
      this.delegateElement.on(
        "change",
        '[data-action="selectbox-change"]',
        this.onVariantChange.bind(this)
      );

      if (this.element.querySelector('[data-action="add-instead"]')) {
        this.delegateElement.on(
          "click",
          '[data-action="add-instead"]',
          this.submitForm.bind(this)
        );
      }

      this.showVariantImage(this.selectedValue);
    }

    if (this.sizeOptionPresent) {
      this.delegateElement.on(
        "click",
        '[data-action="toggle-swiper"]',
        this.showSizeSelector.bind(this)
      );

      this.delegateElement.on(
        "click",
        '[data-size] :checked',
        this.onVariantChange.bind(this)
      );

      this.delegateElement.on(
        "mouseleave",
        '[data-action="unhover"]',
        this.hideSizeSelector.bind(this)
      );
    } else {
      this.delegateElement.on(
        "click",
        '[data-action="toggle-swiper"]',
        this.submitForm.bind(this)
      );
    }
  }

  showSizeSelector(e) {
    e.preventDefault();
    this.sizeSelector.style.display = 'flex';
    e.target.closest('[data-action="toggle-swiper"]').style.display = 'none';
    if (this.selectorInit == false) {
      this.initCarousel();
      this.selectorInit = true;
    }

  }

  hideSizeSelector() {
    setTimeout(() => {
      this.sizeSelector.style.display = 'none';
      this.element.querySelector('[data-action="toggle-swiper"]').style.display = '';
    }, 300);
  }

  initCarousel() {
    const sizeOfSelectors = this.sizeSelector.querySelector('.swiper-wrapper').scrollWidth;
    const sizeOfCard = this.element.offsetWidth - 48;


    if (this.sizeOptionPresent && new Responsive().matchesBreakpoint('lap-and-up')) {
      if (sizeOfSelectors > sizeOfCard) {
        const allButtons = this.element.querySelectorAll('.product-card__swiper-button');
        allButtons.forEach((item) => {
          item.style.visibility = 'visible';
        })
        const sizeSwiper = this.element.querySelector(".swiper");
        new Swiper(sizeSwiper, {
          slidesPerView: "auto",
          spaceBetween: 0,
          resistanceRatio: 0,
          nested: true,
          allowTouchMove: true,
          navigation: {
            nextEl: `.product-card-next-${this.sizeSelector.dataset.id}`,
            prevEl: `.product-card-prev-${this.sizeSelector.dataset.id}`,
          },
          mousewheel: {
            forceToAxis: true
          }
        });
      } else {
        this.sizeSelector.closest('.product-card__actions').classList.add('no-swiper-card')
        this.sizeSelector.classList.add('center-slides')
      }
    }

  }

  onVariantChange(e) {
    const value = e.target.closest('.product-card__input-selectbox')?.value;

    this.updateOptions();
    this.updateMasterId();
    this.updateVariantInput();

    if (value) {
      this.showVariantImage(value);
    }

    if (e.target.closest('.product-card__size-selector')) {
      this.submitForm();
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("input:checked"),
      (select) => select.value
    );
    console.log(this.options);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      console.log(variant);
      return this.options.every((option) => {
        return variant.options.includes(option);
      });
    });
  }

  updateVariantInput() {
    if (!this.atcButton) return;
    const productForm = this.element.querySelector(`.product-form`);
    const input = productForm.querySelector('input[name="id"]');
    console.log(this.currentVariant);
    input.value = this.currentVariant.id;
  }

  submitForm(e) {
    if (e) e.preventDefault();
    this.productForm.querySelector('[data-action="add-to-cart"]').click();
  }

  showVariantImage(value) {
    this.element
      .querySelectorAll(".show")
      .forEach((el) => el.classList.remove("show"));
    const variantImg = this.element.querySelector(
      `.product-card__image[data-image-id="${value}"]`
    );
    const hoverImg = this.element.querySelector(
      `.product-card__image--hover[data-image-id="${value}"]`
    );
    variantImg?.classList.add("show");
    hoverImg?.classList.add("show");

    this.selectedValue = value;
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(
        this.element.querySelector('[type="application/json"]').textContent
      );

    return this.variantData;
  }
}
customElements.define("product-card", ProductCard);

class ProductDrawer extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.drawer = new Drawer(this.element.querySelector("#productDrawer"));
    this.domDelegate = new Delegate(document.body);
    this.delegateElement = new Delegate(this.element);
    this.drawerContent = this.element.querySelector(".Drawer--Content");

    this.bindEvents();
  }

  bindEvents() {
    this.domDelegate.on("product:opened", this.replaceContent.bind(this));

    this.delegateElement.on(
      "change",
      '[data-action="selectbox-change"]',
      this.onVariantChange.bind(this)
    );

    this.delegateElement.on(
      "click",
      'input[checked]',
      this.onVariantChange.bind(this)
    );
  }

  replaceContent(e) {
    this.productId = e.detail.product;
    this.colorOption = e.detail.colorOption;

    const sizeOptions = document.querySelector(
      `.product-card__size-selector[data-productid="${this.productId}"]`
    );
    const atcForm = document.querySelector(
      `.product-card__actions form[data-productid="${this.productId}"]`
    );

    if (sizeOptions && atcForm) {
      while (this.drawerContent.firstChild) {
        this.drawerContent.removeChild(this.drawerContent.firstChild);
      }

      const optionsClone = sizeOptions.cloneNode(true);
      const formClone = atcForm.cloneNode(true);
      optionsClone.querySelectorAll('input').forEach(input => input.id = input.id + 'drawer');
      optionsClone.querySelectorAll('label').forEach(label => label.setAttribute("for", label.getAttribute("for") + 'drawer'));

      formClone.setAttribute("id", formClone.getAttribute("id") + "_drawer");

      this.drawerContent.appendChild(optionsClone);
      this.drawerContent.appendChild(formClone);
      this.productForm = formClone;

    }
  }

  onVariantChange(e) {
    this.updateOptions();
    this.updateMasterId();
    this.updateVariantInput();
    this.submitForm();
  }

  updateOptions() {
    this.options = [];
    const sizeOption = this.querySelector("input:checked").value;

    this.options.push(sizeOption)
    if (this.colorOption) {
      this.options.push(this.colorOption);
    }
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return this.options.every((option) => {
        return variant.options.includes(option);
      });
    });
  }

  updateVariantInput() {
    if (!this.productForm || !this.currentVariant) return;
    const input = this.productForm.querySelector('input[name="id"]');
    input.value = this.currentVariant.id;
  }

  submitForm() {
    this.productForm.querySelector('[data-action="add-to-cart"]').click();
 
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(
        document.querySelector(`[type="application/json"][data-productid="${this.productId}"]`).textContent
      );
    return this.variantData;
  }
}
customElements.define("product-drawer", ProductDrawer);

class Loader extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.element.style.background = this.element.dataset.background;

    if (this.dataset.first === "true") {
      // Checks if we opened site in a new tab
      const loaderShown = localStorage.getItem('loader_shown');
      localStorage.setItem('loader_shown', 'true');

      if (loaderShown) {
        this.element.remove();
        return;
      }
    } else {
      // Checks if we refreshed the page
      const pageAccessedByReload = (
        (window.performance.navigation && window.performance.navigation.type === 1) ||
        window.performance
          .getEntriesByType('navigation')
          .map((nav) => nav.type)
          .includes('reload')
      );

      // Checks if we opened site in a new tab
      const isNewTab = (sessionStorage.getItem('is_old_tab') != 'true');
      sessionStorage.setItem('is_old_tab', 'true');

      if (!isNewTab && !pageAccessedByReload) {
        this.element.remove();
        return;
      }
    }

    this.domContentLoaded = false;
    this.animationEnded = false;

    this.lottiePlayer = this.element.querySelector('lottie-player');
    bodyScrollLock.disableBodyScroll(document.body, bodyScrollLockOptions);

    this.bindEvents();
  }

  bindEvents() {
    this.onAnimationEndBinder = this.onAnimationEnd.bind(this);
    this.lottiePlayer.addEventListener("complete", this.onAnimationEndBinder);

    document.addEventListener("DOMContentLoaded", () => {
      this.domContentLoaded = true;
      if (this.animationEnded) {
        this.endAnimation();
      }
    });
  }

  endAnimation() {
    this.element.classList.add('hide');
    this.lottiePlayer.removeEventListener("complete", this.onAnimationEndBinder);
    bodyScrollLock.clearAllBodyScrollLocks();
    setTimeout(() => {
      this.element.display = 'none';
    }, 500);
  }

  onAnimationEnd() {
    this.animationEnded = true;
    if (this.domContentLoaded) {
      this.endAnimation();
    }
  }
}
customElements.define("loader-element", Loader);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.options = JSON.parse(this.element.getAttribute("data-settings"));
    if (this.options["showRecommendations"]) {
      this.loadRecommendations();
    }
  }

  loadRecommendations() {
    if (this.options["productId"] == "") {
      var url = "?section_id=helper-recommendations";
    } else {
      var url =
        window.routes.localeRootUrl +
        "/recommendations/products?section_id=helper-recommendations&product_id=" +
        this.options["productId"] +
        "&limit=10";
    }

    var _this = this;
    return fetch(url).then(function (response) {
      return response
        .text()
        .then(function (content) {
          var container = document.createElement("div");
          container.innerHTML = content;
          var z = container.querySelector(".cartUpsell").innerHTML;
          var x = _this.element.querySelector(".withItemRecommendations");
          x.innerHTML = z;

          const swiper = new Swiper(".swiperUpsell", {
            // Default parameters
            slidesPerView: 2,
            spaceBetween: 16,
            navigation: false,
            loop: false,
            allowTouchMove: true,
            mousewheel: {
              forceToAxis: true,
            },
            navigation: {
              nextEl: ".swiperNextCart",
              prevEl: ".swiperButtonPrevious",
            },
            breakpoints: {
              1025: {
                slidesPerView: 4,
                spaceBetween: 16,
              },
            },
          });
        })
        .catch((e) => {
          console.error(e);
        });
    });
  }
}
customElements.define("cart-items", CartItems);

class Search extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);

    // Find result elements
    this.resultElements = this.element.querySelectorAll(".Search--Result");

    this.filterSearchBars = this.element.querySelector(".templateSearch .FilterBar");
    // Find buttons to toggle between products and articles
    this.openProductBtn = this.element.querySelector("#productBtn");
    this.openArticleBtn = this.element.querySelector("#articleBtn");

    this.bindEvents();



  }

  bindEvents() {
    // Toggle between products and articles when buttons are clicked
    this.delegateElement.on(
      "click",
      '[data-action="toggle-products"]',
      this.showProducts.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="toggle-articles"]',
      this.showArticles.bind(this)
    );

    this.delegateElement.on("filters:rerendered", () =>
      setTimeout(() => this.updateResultNumber(), 100)
    );

    document.addEventListener(
      "DOMContentLoaded",
      this.updateResultNumber.bind(this)
    );

  }

  updateResultNumber() {

    // Find number of products and articles and display them
    const productElements = this.element.querySelectorAll(
      ".SearchProductWrapper"
    );
    const productNumber = productElements.length;
    const itemNumber = this.element.querySelector(".itemNumber");
    if (productNumber === 0) {
      this.filterSearchBars.style.display = "none";
    }
    if (itemNumber) {
      itemNumber.innerHTML = productNumber;
      if (productNumber === 0) {
        this.openProductBtn.style.display = "none";
      }
    }

    const articleElements = this.element.querySelectorAll(".article-wrapper");
    const articleNumber = articleElements.length;
    const itemNumber_2 = this.element.querySelector(".itemNumber_2");
    if (itemNumber_2) {
      itemNumber_2.innerHTML = articleNumber;
      if (articleNumber === 0) {
        this.openArticleBtn.style.display = "none";
      }
    }

    if (productNumber !== 0) {
      this.showProducts();
    }
    if (productNumber === 0 && articleNumber !== 0) {
      this.showArticles();
    }
  }


  showProducts() {

    //hide filters and search
    this.element.querySelector('.templateSearch .FilterBar').style.display = "flex";
    // Show product elements and hide article elements
    const productElements = this.element.querySelectorAll(
      ".SearchProductWrapper"
    );
    const productNumber = productElements.length;
    if (!productElements.length) {
      return;
    }
    const articleElements = this.element.querySelectorAll(".article-wrapper");
    articleElements.forEach((article) => {
      article.classList.add("hidden");
    });
    productElements.forEach((product) => {
      product.classList.remove("hidden");
    });
    //show filter and searh bar
    if (productNumber === 0) {
      this.element.querySelector('.templateSearch .FilterBar').style.display = "none";
    } else {
      this.element.querySelector('.templateSearch .FilterBar').style.display = "flex";
    }

    // Update button styles
    this.openProductBtn = this.element.querySelector("#productBtn");
    this.openArticleBtn = this.element.querySelector("#articleBtn");
    this.openProductBtn.classList.add("active");
    this.openArticleBtn.classList.remove("active");
  }

  showArticles() {

    //hide filters and search
    this.element.querySelector('.templateSearch .FilterBar').style.display = "none";

    // Show article elements and hide product elements
    const articleElements = this.element.querySelectorAll(".article-wrapper");
    if (!articleElements.length) {
      return;
    }
    const productElements = this.element.querySelectorAll(
      ".SearchProductWrapper"
    );
    productElements.forEach((product) => {
      product.classList.add("hidden");
    });
    articleElements.forEach((article) => {
      article.classList.remove("hidden");
    });

    // Update button styles
    this.openProductBtn = this.element.querySelector("#productBtn");
    this.openArticleBtn = this.element.querySelector("#articleBtn");
    this.openProductBtn.classList.remove("active");
    this.openArticleBtn.classList.add("active");
  }
}

customElements.define("search-component", Search);


class CommentSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.whireCommentBtn = this.element.querySelector(".Comments--WhireButton");
    this.revealWrapper = this.element.querySelector(".Comments--RevealWrapper");
    this.currentPageKey = this.extractStringFromURL(window.location.href);
    this.options = JSON.parse(this.getAttribute("data-settings"));
    this.articleWrapper = this.element.querySelector(
      ".Comments--ArticleWrapper"
    );
    if (this.articleWrapper)
      this.allChildren = Array.from(this.articleWrapper.children);
    this.paginationWrapper = this.element.querySelector(".Pagination-Wrapper");

    const requiredCheckboxes = document.querySelectorAll(
      "input.Comments--Required"
    );

    if (requiredCheckboxes.length > 0) {
      this.element.querySelector('.Comments--SendButton').style.opacity = 0.2;
      this.element.querySelector('.Comments--SendButton').style.pointerEvents = "none";
    }

    const beenHere = sessionStorage.getItem("postRequest");
    if (beenHere == this.currentPageKey) {
      this.revealWrapper.style.height = "fit-content";
      this.whireCommentBtn.style.display = "none";
    } else {
      this.bindWhireBtnListener();
    }

    this.mobile = new Responsive().matchesBreakpoint;


    this.handleAfterState();
    this.bindListeners();
  }

  bindListeners() {
    this.delegateElement.on(
      "click",
      '[data-action="load-more"]',
      this.loadMore.bind(this)
    );
    this.textArea = this.element.querySelector("#CommentForm-body");
    const formListener = this.element.querySelector("#comment_form");

    this.textAreaFunc = this.expandDynamically.bind(this);

    formListener.addEventListener("submit", this.verifyForm.bind(this));
    window.addEventListener("resize", this.onResize.bind(this));

    this.delegateElement.on('change', '[data-state="required"]', this.verifyClick.bind(this));

  }

  verifyClick() {
    const requiredCheckboxes = document.querySelectorAll(
      "input.Comments--Required"
    );

    let verified = true;

    requiredCheckboxes.forEach((item) => {

      if (item.checked == false) {

        verified = false;
      }
    })

    if (verified == true) {
      this.element.querySelector('.Comments--SendButton').style.opacity = 1;
      this.element.querySelector('.Comments--SendButton').style.pointerEvents = "all";
    } else {
      this.element.querySelector('.Comments--SendButton').style.opacity = 0.2;
      this.element.querySelector('.Comments--SendButton').style.pointerEvents = "none";
    }
  }

  handleAfterState() {
    if (window.location.href.indexOf("#comment_form") > -1) {
      this.element
        .querySelector(".Comments--WhireButton")
        .setAttribute("aria-hidden", "true");
    }
  }

  loadMore(event, target) {
    const _this = this;
    let dataHref = target.getAttribute("data-href");

    return fetch(window.routes.localeRootUrl + dataHref, {
      credentials: "same-origin",
      method: "GET",
    }).then(function (content) {
      content.text().then(function (htmlData) {
        let html = new DOMParser().parseFromString(htmlData, "text/html");
        let newComments = html.querySelectorAll(".ArticleComments--Comment");

        let curDocument = _this.element.querySelector(".ArticleComments");
        curDocument.append(...newComments);
        let dataHref = html.querySelector("[data-href]");

        if (dataHref) {
          dataHref = dataHref.dataset.href;
          _this.element.querySelector("[data-href]").dataset.href = dataHref;
        } else {
          _this.element.querySelector(".comments--buttonFooter")?.remove();
        }
      });
    });
  }
  reduceArticles() {
    if (this.paginationWrapper) this.paginationWrapper.style.display = "none";

    if (this.articleWrapper) {
      while (this.articleWrapper.children.length > 3) {
        this.articleWrapper.removeChild(this.articleWrapper.lastChild);
      }
    }
  }

  updateComments() {
    this.loadMoreBtn.style.display = "none";

    for (const child of this.allChildren) {
      this.articleWrapper.appendChild(child);
    }

    this.paginationWrapper.style.display = "block";
    sessionStorage.setItem("openedComments", true);
  }

  verifyForm(e) {
    const requiredCheckboxes = document.querySelectorAll(
      "input.Comments--Required"
    );
    const uncheckedCheckboxes = [];

    requiredCheckboxes.forEach((checkbox) => {
      if (!checkbox.checked) {
        e.preventDefault();
        uncheckedCheckboxes.push(checkbox);
      }
    });

    if (uncheckedCheckboxes.length > 0) {
      uncheckedCheckboxes.forEach((checkbox) => {
        const errorMessageElement = checkbox.parentElement.querySelector(`label[for=${checkbox.id}]`)?.querySelector(".Comments--ErrorMessage");
        if (errorMessageElement)
          errorMessageElement.classList.add("showCommentErrorMsg");
      });
    } else {
      if (this.currentPageKey.includes("#comment_form")) {
        sessionStorage.setItem("postRequest", this.currentPageKey);
      } else {
        sessionStorage.setItem(
          "postRequest",
          this.currentPageKey + "#comment_form"
        );
      }
    }
  }

  onResize() {
    if (window.innerWidth < 1024) {
      this.textArea.addEventListener("input", this.textAreaFunc);
      this.expandDynamically();
      this.mobile = true;
    } else {
      this.textArea.removeEventListener("input", this.textAreaFunc);
      this.textArea.style.height = "128px";
      this.mobile = false;
    }
  }

  expandDynamically() {
    this.textArea.style.height = "42px";

    const scrollHeight = Math.max(
      this.textArea.scrollHeight,
      this.textArea.clientHeight
    );
    if (scrollHeight < 42) return;
    this.textArea.style.height = scrollHeight + "px";
  }

  extractStringFromURL(url) {
    const parts = url.split("/");
    return parts[parts.length - 1];
  }

  calculateFitContentHeight(elem) {
    const clone = elem.cloneNode(true);
    clone.style.visibility = "hidden";
    clone.style.height = "fit-content";
    this.element.appendChild(clone);
    const computedHeight = window.getComputedStyle(clone).height;
    this.element.removeChild(clone);

    return computedHeight;
  }

  bindWhireBtnListener() {
    this.wooshListener = this.woosh.bind(this);
    this.whireCommentBtn.addEventListener("click", this.wooshListener);
  }

  woosh(e) {
    e.preventDefault();
    this.whireCommentBtn.style.opacity = "0";
    this.whireCommentBtn.style.pointerEvents = "none";
    if (this.mobile) this.whireCommentBtn.style.marginTop = "-68px";

    const height = this.calculateFitContentHeight(this.revealWrapper);
    this.revealWrapper.style.height = height;
    setTimeout(() => {
      this.revealWrapper.style.height = "fit-content";
      this.whireCommentBtn.style.display = "none";
    }, 1000);

    this.whireCommentBtn.removeEventListener("click", this.wooshListener);
  }
}
customElements.define("comment-section", CommentSection);
class BlogShowcase extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.carouselElement = this.element.querySelector(".swiper");
    this.carousel = new RevolutionSwiper(this.carouselElement);
    this.swiper = this.carouselElement.swiper;
    this.navButtons = this.element.querySelectorAll(".swiperButton");

    if (this.navButtons.length > 0) {
      document.addEventListener("DOMContentLoaded", () => {
        const height =
          this.carouselElement.querySelector(".swiper-slide").offsetWidth;
        this.navButtons.forEach(
          (button) => (button.style.top = height / 2 + "px")
        );
      });
    }

    if (this.element.getAttribute("data-action") === "autoplay") {
      const mediaQuery = window.matchMedia("(min-width: 1025px)");
      mediaQuery.addEventListener(
        "change",
        this.handleBreakpointTriggered.bind(this)
      );
      this.handleBreakpointTriggered(mediaQuery);
    }
  }

  handleBreakpointTriggered(mql) {
    if (mql.matches) {
      if (this.observer) this.observer.unobserve(this.element);
    } else {
      this.bindObserver();
    }
  }

  bindObserver() {
    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 0,
    };

    const callback = (entries) => {
      entries.forEach((entry) => {
        entry.isIntersecting
          ? this.swiper.autoplay.resume()
          : this.swiper.autoplay.pause();
      });
    };

    this.observer = new IntersectionObserver(callback, options);
    this.observer.observe(this.element.querySelector(".swiper"));
  }
}
customElements.define("blog-showcase", BlogShowcase);

class MainBlog extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.tagSwiper = this.element.querySelector(".main-blog__tag-swiper");
    this.carousel = new RevolutionSwiper(this.tagSwiper);



  }
}
customElements.define("blog-section", MainBlog);

class SizeGuideDrawer extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.drawerElement = this.element.querySelector("#sizeGuideDrawer");
    this.drawer = new Drawer(this.drawerElement);
    this.delegateElement = new Delegate(this.element);
    this.sizeGuideButton = this.element.querySelector('.size-guide__button');

    this.bindEvents();
  }

  bindEvents() {
    this.delegateElement.on(
      "click",
      '[data-action="show-page"]',
      this.showPage.bind(this)
    );

  }

  showPage(e) {
    this.element.querySelector('.Drawer--PageButton[aria-expanded="true"]')?.setAttribute("aria-expanded", "false");
    this.element.querySelector('.Drawer--PageContent[aria-hidden="false"]')?.setAttribute("aria-hidden", "true");

    const target = e.target.closest('button');
    if (this.sizeGuideButton) {
      if (target.classList.contains('hide-button')) {
        this.sizeGuideButton.style.display = 'none';
      } else {
        this.sizeGuideButton.style.display = '';
      }
    }

    this.element.querySelector(`.Drawer--PageButton[data-id="${target.dataset.id}"]`)?.setAttribute("aria-expanded", "true");
    this.element.querySelector(`.Drawer--PageContent[data-id="${target.dataset.id}"]`)?.setAttribute("aria-hidden", "false");
  }
}
customElements.define("size-guide-drawer", SizeGuideDrawer);

class SelectorsDrawer extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.drawerElement = this.element.querySelector("#selectorsDrawer");
    this.drawer = new Drawer(this.drawerElement);
  }
}
customElements.define("selectors-drawer", SelectorsDrawer);

class SectionQuote extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delElem = new Delegate(this.element)
    let animation = this.element.querySelector(".quote--wrapper");

    if (this.element.querySelectorAll('.quote--swiper .swiper-slide').length > 1) {
      this.startSwiper();

      this.bindEvents();
    }
    if (animation.getAttribute("data-anim") == "true") {
      this.parseQuotes();
      this.createIntersection();
    }

  }

  bindEvents() {
    this.delElem.on("click", '[data-action="toggle-swiper"]', this.handleTogleSwiper.bind(this));
    this.swiper.on('slideChange', this.updateQuote.bind(this));
  }

  handleTogleSwiper() { 
    this.carousel.toggleSwiper(event.target)
  }

  startSwiper() {
    this.carouselElement = this.element.querySelector(".swiper");
    const pauseButton = this.element.querySelector('[data-action="pause-swiper"]') ? true : false;
    const useTumbs = false;

    this.carousel = new RevolutionSwiper(this.carouselElement, useTumbs, pauseButton);
    this.swiper = this.carousel.swiperElement;
  }

  createIntersection() {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        this.updateQuote();
      });
    });

    observer.observe(this.element);
  }

  updateQuote() {

    var keyframes = [
      { color: 'var(--primary_text)' },
      { color: 'var(--primary_text)' }
    ];

    var options = {
      duration: 200,
      easing: 'linear',
      fill: 'forwards'
    };

    var delay = 0;

    //Remove color from old slide
    if (this.currentSlide) {
      var words = this.currentSlide.querySelectorAll('.Quote--Letter')
      words.forEach(function (elem) {
        var keyframes2 = [
          { color: '#E8E8E8' }
        ];

        var options2 = {
          duration: 300,
          fill: 'forwards'
        };

        elem.animate(keyframes2, options2);
      })
    }

    //Animate new slide
    if(this.swiper){
      this.currentSlide = this.swiper.slides[this.swiper.activeIndex];
    } else {
      this.currentSlide = this.element;
    }


    var words = this.currentSlide.querySelectorAll('.Quote--Letter')
    words.forEach((elem, index) => {
      options.delay = delay;
      const animation = elem.animate(keyframes, options);
      delay += 30;
      if (index === words.length - 1 && this.element.dataset.autoplay && this.swiper) {
        animation.onfinish = () => {
          this.carousel.nextSlide();
        };
      }
    })
  }

  parseQuotes() {
    this.element.querySelectorAll('.quote--title').forEach((elem) => {

      var words = elem.textContent.split(' ');

      elem.innerHTML = words.map(function (word) {
        var letters = word.split('');
        letters = letters.map(function (l) {
          return '<span class="Quote--Letter u-h4">' + l + '</span>';
        }).join('');

        return '<span class="Quote--Word">' + letters + ' </span>';
      }).join('');


    })
  }
}
customElements.define("section-quote", SectionQuote);


class shopTheLook extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    document.addEventListener("DOMContentLoaded", () => {
      this.carouselElement = this.element.querySelector(".swiper");
      this.carousel = new RevolutionSwiper(this.carouselElement);
      this.bindEvents();
    });

  }

  bindEvents() {
    this.onSlideChangeListener = this.onSlideChange.bind(this);
    this.element.addEventListener("swiper:slide-changed", this.onSlideChangeListener);

    this.delegateElement.on('click', '[data-action="select-dot"]', this.handleDotSelection.bind(this));
  }

  handleDotSelection() {
    const previousDot = this.element.querySelector('[aria-selected="true"]');
    previousDot.removeAttribute('aria-selected');
    event.target.setAttribute('aria-selected', 'true');
    const index = parseInt(event.target.dataset.index);

    this.carousel.selectCell(index);
  }

  onSlideChange() {
    const swiperButton = this.element.querySelector('.stl-swiper_previous');
    swiperButton.removeAttribute('style');
    const index = event.detail.currentIndex;
    const previousDot = this.element.querySelector('[aria-selected="true"]');
    previousDot.removeAttribute('aria-selected');

    const nextDot = this.element.querySelector(`[data-index="${index}"]`);
    if (!nextDot) return;
    this.element.querySelector(`[data-index="${index}"]`).setAttribute('aria-selected', 'true');
  }

}
customElements.define("shop-the-look", shopTheLook);

class HeadingText extends HTMLElement {
  constructor() {
    super();
    this.element = this;

    if (this.element.dataset.reveal) {
      this.parseText();
      this.settings();
      this.bindEvents();
      this.element.style.color = '#E8E8E8';
    }


  }

  bindEvents() {

    window.addEventListener("scroll", this.handleScroll.bind(this));
  }

  settings() {
    this.keyframesFill = [{ color: "var(--primary_text)" }];

    this.keyframesReset = [{ color: "#E8E8E8" }];

    this.options = {
      duration: 300,
      easing: "linear",
      fill: "forwards",
    };

    this.textBox = this.element.querySelector(".HeadingSubheading--wrapper");
    this.letters = this.textBox.querySelectorAll(".custom-one__letter");

    this.scrollDistancePerLetter =
      (window.innerHeight - 350) / this.totalLetters;
  }

  handleScroll() {
    this.containerRect = this.element.getBoundingClientRect();
    const scrollPosition =
      window.innerHeight - 350 - this.textBox.getBoundingClientRect().top;

    this.letters.forEach((letter, index) => {
      const letterScrollPosition = index * this.scrollDistancePerLetter;
      if (letterScrollPosition <= scrollPosition) {
        letter.animate(this.keyframesFill, this.options);
      } else {
        letter.animate(this.keyframesReset, this.options);
      }
    });
  }

  parseText() {
    this.totalLetters = 0;
    this.element.querySelectorAll(".heading-text-reveal").forEach((elem) => {
      const words = elem.textContent.split(" ");
      const font = elem.dataset.font;
      elem.innerHTML = words
        .map((word) => {
          let letters = word.split("");
          this.totalLetters += letters.length;
          letters = letters
            .map((letter) => {
              return (`<span class="custom-one__letter ${font}">${letter}</span>`);
            })
            .join("");
          return `<span class="custom-one__word">${letters}</span>`;
        })
        .join(" ");
    });

  }
}
customElements.define("heading-text", HeadingText);


class ImageZoomOut extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    if (this.element.dataset.zoom) {
      this.images = this.element.querySelectorAll('img'); // Selects both mobile and desktop images
      this.observer = null;
      this.handleScroll = this.handleScroll.bind(this);
      this.initObserver();
    }
  }

  initObserver() {
    const options = {
      root: null,  // observing with respect to the viewport
      rootMargin: '0px',
      threshold: 0.01
    };

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          window.addEventListener('scroll', this.handleScroll);
          this.handleScroll(); // Initialize scale when the image first appears
        } else {
          window.removeEventListener('scroll', this.handleScroll);
        }
      });
    }, options);

    this.images.forEach(img => this.observer.observe(img));
  }

  handleScroll() {
    this.images.forEach(img => {
      const rect = img.getBoundingClientRect();
      const viewportHeight = window.innerHeight;

      // Calculate the scale based on the vertical position of the image within the viewport
      const positionInViewport = rect.top - viewportHeight; // Image top relative to the viewport bottom
      const relativePosition = positionInViewport / (viewportHeight + rect.height); // Normalized position
      const scale = 1.1 - 0.1 * Math.abs(relativePosition);

      // Use translate3d for potential performance benefits
      img.style.transform = `translate3d(0, 0, 0) scale(${Math.max(Math.min(scale, 1.1), 1.0)})`;
    });
  }

  disconnectedCallback() {
    if (this.observer) {
      this.images.forEach(img => this.observer.unobserve(img));
      window.removeEventListener('scroll', this.handleScroll);
    }
  }
}

customElements.define("image-zoom-out", ImageZoomOut);

